import React from 'react'
import PropTypes from 'prop-types'

import { Modal, Skeleton, message } from 'antd'

import BucketDetailHeading from './BucketDetailHeading'
import BucketDetailList from './BucketDetailList'
import AddBucketModal from './../feedback/AddBucketModal'
import ConfirmModal from './../feedback/ConfirmModal'
import PublishBucketModal from './../feedback/PublishBucketModal'
import AuthService from './../../../services/AuthService'

import userMessages from '../../../constants/messages'

import { graphql, withApollo } from '@apollo/client/react/hoc'
import _, { cloneDeep, flowRight as compose, isEmpty, isEqual } from 'lodash'
import QueryGetBucketDetails from './../../../graphQL/bucket/getBucketDetails'
import QueryGetBucketUpdatedDetails from './../../../graphQL/bucket/getBucketUpdatedDetails'
import MutationCreateBucketItem from './../../../graphQL/bucket/createBucketItem'
import MutationUpdateBucket from './../../../graphQL/bucket/updateBucket'
import MutationSaveAllBuckets from './../../../graphQL/bucket/saveAllBuckets'
import SubscriptionSaveAllBucket from './../../../graphQL/bucket/saveAllBucketsSubscription'
import MutationUpdateBucketItem from '../../../graphQL/bucket/batchUpdateBucketItem'
import { utilityService } from '../../../services/UtilityService'
import getUuid from 'uuid-by-string'
import moment from 'moment'
import { multiDragAwareReorder, multiSelect } from './utils'
import BucketDetailCellVersion from './BucketDetailCellVersion'
import { ACTIVE_VERSION_DROPPABLE_ID, BUCKET_MANAGER_DARG_ACTION_TYPES, BUCKET_VERSION_MODAL_TYPES, VERSION_DRAGGABLE_ID, VERSION_DROPPABLE_ID } from 'constants/general-constants'
import CreateBucketVersionModal from '../dataEntry/other/CreateBucketVersionModal'
import createBucketVersionMutation from 'graphQL/bucket/createBucketVersionMutation'
import UpdateBucketVersionModal from '../dataEntry/other/UpdateBucketVersionModal'
import updateBucketVersionMutation from 'graphQL/bucket/updateBucketVersionMutation'
import deleteBucketVersionMutation from 'graphQL/bucket/deleteBucketVersion'
import CopyVersionModal from '../dataEntry/other/CopyVersionModal'

const parent = 'bucket-details-container'
let userSessionId = null

/// const reorder = (list, startIndex, endIndex) => {
//   const result = Array.from(list)
//   const [removed] = result.splice(startIndex, 1)
//   result.splice(endIndex, 0, removed)
//   return result
// }

const subscribeChangeInBucket = (subscribeToMore, props, retrying = 50) => {
  return subscribeToMore({
    document: SubscriptionSaveAllBucket,
    variables: { id: props.ownProps.bucketId },
    updateQuery: (prev, { subscriptionData: { data: { bucketSaved } } }) => {
      // if (bucketSaved && bucketSaved.isArchived) {
      //   const variables = { id: data.ownProps.bucketId }
      //   const listCacheData = props.ownProps.client.readQuery({ query: QueryGetBucketDetails, variables })
      //   const index = listCacheData.listBucketGroups.items.findIndex(group => group.id === bucketSaved.id)
      //   if (index !== -1) {
      //     props.ownProps.client.writeQuery({
      //       query: QueryGetBucketGroupList,
      //       data: listCacheData,
      //       variables
      //     })
      //   }
      // }
      if (!bucketSaved || prev.getBucket.id !== bucketSaved.id) return prev
      prev.getBucket = bucketSaved
      return prev
    },
    onError: (error) => {
      if ((error.errorMessage || '').includes('Socket')) {
        setTimeout(() => { subscribeChangeInBucket(subscribeToMore, props, retrying * 2) }, retrying)
      }
    }
  })
}

const deleteWarningMessage = {
  title: 'Delete Bucket?',
  message: 'Do you want to delete this bucket from bucket group'
}

const ACTION_TYPES = {
  ACTION_ON_BUCKET_VERSION: 'ACTION_ON_BUCKET_VERSION'
}

const COPY_OPTIONS_ID_TYPES = {
  DEFAULT: 'DEFAULT',
  VERSION: 'VERSION'
}
class BucketDetailCell extends React.Component {
  BucketDetailCellVersionRef = {}
  constructor (props) {
    super(props)
    this.state = {
      bucketDetails: _.cloneDeep(props.bucketDetails),
      isSearch: false,
      isEditted: false,
      isSaveEnable: false,
      saveLoading: false,
      addFilterLoading: false,
      isScroll: false,
      isWarningShow: false,
      isModifiedLoading: false,
      updatedBucketItem: [],
      draggingTaskId: null,
      entities: this.loadBucketDetailsTolistData(_.cloneDeep(props.bucketDetails)),
      listData: [],
      selectedTaskIds: [],
      entitiesInsideVersions: {},
      selectedTaskIdsInsideVersions: [],
      showBucketVersions: false,
      updatedVersionBucketItems: {},
      updatedVersionBucketItemsForTrackingMetaChanges: {},
      basicDateRangeDetails: null,
      versionBucketItemsOrderTracker: [],
      bucketDetailsForComparison: this.props.bucketDetailsForComparison
    }
    this.changedBucketItem = []
    if (props.bucketId && props.isLoading) {
      props.changeLoadingBucket(props.bucketId, 'ADD')
    }
  }

  componentDidMount = () => {
    this.getUserDetails()
    if (this.props.bucketDetails) {
      if (this.props.isLoading) {
        this.props.changeLoadingBucket(this.props.bucketId, 'ADD')
      }
    }
    // this.initiateSubscription()
  }

  componentDidUpdate (prevProps, prevState) {
    const { showBucketVersions, bucketDetails } = this.state
    const { isVersionOnlyMode, bucketId, handleBucketVersionMode, updateBucketVersionModalId } = this.props
    // when back button is clicked from parent component, hide bucket versions
    if (isVersionOnlyMode !== prevProps.isVersionOnlyMode) {
      if (!isVersionOnlyMode) {
        const copyOfShowBucketVersions = cloneDeep(showBucketVersions)
        delete copyOfShowBucketVersions[bucketId]
        this.setState({ showBucketVersions: copyOfShowBucketVersions, updatedVersionBucketItems: {} })
        handleBucketVersionMode(false, bucketId)
      }
    }

    // when updateBucketVersionModalId changes make date range object for edit popup
    if (updateBucketVersionModalId !== prevProps.updateBucketVersionModalId) {
      const versionItem = bucketDetails?.versions?.find(versionItem => versionItem.id === updateBucketVersionModalId)
      if (!isEmpty(versionItem)) {
        this.setState({
          basicDateRangeDetails: {
            basicStartDate: versionItem.publishStartDate,
            basicEndDate: versionItem.publishEndDate
          }
        })
      }
    }

    if (!isEqual(prevProps.bucketDetailsForComparison, this.props.bucketDetailsForComparison)) {
      this.setState({
        bucketDetailsForComparison: this.props.bucketDetailsForComparison
      })
    }

    if (!isEqual(prevProps.bucketDetails, this.props.bucketDetails)) {
      const versionList = this.props.bucketDetails?.versions || []
      // const versionDetails = this.getVersionDetails(versionList)
      // const currentActiveBucketVersion = versionDetails?.currentActiveBucketVersion
      // console.log('currentActiveBucketVersion', currentActiveBucketVersion)
      // if (!isEmpty(currentActiveBucketVersion)) {
      //   this.updateEntities(currentActiveBucketVersion.bucketItems, currentActiveBucketVersion.id)
      // }
      let entitiesInsideVersions = {}
      versionList.forEach(versionItem => {
        const newEntities = this.loadVersionBucketDetailsTolistData(cloneDeep(versionItem.bucketItems), versionItem.id)
        entitiesInsideVersions[versionItem.id] = newEntities
      })
      this.setState({
        entitiesInsideVersions
      })
    }
  }

  loadBucketDetailsTolistData = (bucketDetails) => {
    if (bucketDetails && bucketDetails.bucketItems && !_.isEmpty(bucketDetails.bucketItems)) {
      let tasks = {}
      const listData = this.getSortedList(cloneDeep(bucketDetails.bucketItems))
      const list = listData.map((task) => {
        tasks = {
          ...tasks,
          [task.id]: task
        }
        return task.id
      })
      const entities = {
        columnOrder: ['#Bucket_' + bucketDetails.id],
        columns: {
          ['#Bucket_' + bucketDetails.id]: {
            id: '#Bucket_' + bucketDetails.id,
            taskIds: list
          }
        },
        tasks
      }
      return entities
      // this.setState({
      //   entities
      // })
    }
  }

  loadVersionBucketDetailsTolistData = (bucketDetailList, versionId) => {
    // if (bucketDetails && bucketDetails.bucketItems && !_.isEmpty(bucketDetails.bucketItems)) {
    let tasks = {}
    const listData = this.getSortedList(cloneDeep(bucketDetailList))
    const list = listData.map(task => {
      tasks = {
        ...tasks,
        [task.id]: task
      }
      return task.id
    })
    const entities = {
      columnOrder: ['#Bucket_' + versionId],
      columns: {
        ['#Bucket_' + versionId]: {
          id: '#Bucket_' + versionId,
          taskIds: list
        }
      },
      tasks
    }
    return entities
    // this.setState({
    //   entities
    // })
    // }
  }

  UNSAFE_componentWillReceiveProps = newProps => { // eslint-disable-line camelcase
    if (newProps.isSaveAllClicked) {
      this.saveBucket(true)
    }
    if (newProps.isForceSave) {
      this.saveBucket(true)
    }
    if (!_.isEqual(newProps.bucketListData, this.state.listData) && !this.state.saveLoading && !this.state.addFilterLoading) {
      this.setState({ listData: newProps.bucketListData })
    }
    if (!_.isEqual(newProps.bucketDetails, this.props.bucketDetails) && !this.state.saveLoading && !this.state.isSaveEnable) {
      // if (newProps.bucketId !== this.props.bucketId) {
      this.props.changeLoadingBucket(newProps.bucketDetails.id, 'REMOVE')
      // }

      if (newProps.bucketId === this.props.id) {
        let bucketDetails = _.cloneDeep(newProps.bucketDetails)
        let bucketItems = this.state.bucketDetails.bucketItems
        bucketDetails.bucketItems = bucketItems
        this.setState({
          bucketDetails,
          entities: this.loadBucketDetailsTolistData(bucketDetails)
        })
      } else {
        let bucketDetails = _.cloneDeep(newProps.bucketDetails)
        this.setState({
          bucketDetails,
          entities: this.loadBucketDetailsTolistData(bucketDetails)
        })
      }
    } else if (newProps.bucketDetails && !_.isEqual(newProps.bucketDetails.status, this.props.bucketDetails.status)) {
      let bucketDetails = _.cloneDeep(this.state.bucketDetails)
      bucketDetails.status = newProps.bucketDetails.status
      this.setState({ bucketDetails })
    } else if (newProps.bucketDetails && !_.isEqual(newProps.bucketDetails, this.state.bucketDetails)) {
      let bucketDetails = _.cloneDeep(this.state.bucketDetails)
      if (this.state.isSaveEnable && !this.state.saveLoading) {
        const isLatest = moment(newProps.bucketDetails.updatedAt).isAfter(moment(bucketDetails.updatedAt), 'seconds')
        // const tempSessionId = sessionStorage.getItem('user_session_id')
        if (isLatest) {
          this.setState({ isWarningShow: true, saveLoading: false, tempBucketDetails: newProps.bucketDetails })
        }
      } else if (bucketDetails && bucketDetails.bucketItems) {
        bucketDetails.bucketItems = (bucketDetails.bucketItems || []).map((item) => {
          const currentItem = (newProps.bucketDetails.bucketItems).find((bucket) => bucket.id === item.id)
          if (!_.isEmpty(currentItem)) { item.asset = item.asset ? currentItem.asset : null }
          return item
        })
      }
      // TODO :: this temporary fix of commenting bucketDetails state updation is for fixing refetch bucket detais popup appearing all the time, updatedAt tag was not getting updated in local state with latest data from response
      this.setState({
        // bucketDetails,
        entities: this.loadBucketDetailsTolistData(bucketDetails)
      })
    }
    if (!_.isEqual(newProps.bucketDetails, this.props.bucketDetails) && !this.state.saveLoading && !this.state.isSaveEnable) {
      if (newProps.bucketDetails && !newProps.isLoading) {
        this.props.changeLoadingBucket(newProps.bucketDetails.id, 'REMOVE')
      }
    }
    if (newProps.draggable && newProps.droppableId && (!this.props.draggable || newProps.draggable.randomKey !== this.props.draggable.randomKey)) {
      const buckets = {
        type: 'ASSET',
        assetId: newProps.draggable.id,
        bucket: newProps.droppableId,
        position: newProps.destinationIndex
      }
      const tempId = getUuid(newProps.droppableId + newProps.draggable.id)
      const tempAsset = {
        id: tempId,
        asset: newProps.draggable,
        type: 'ASSET',
        position: newProps.destinationIndex,
        isLoading: true
      }
      let bucketListDetails = this.state.bucketDetails
      let bucketItems = _.cloneDeep(this.state.bucketDetails.bucketItems)
      const isAssetPresent = (bucketItems || []).find((item) => item.asset && item.asset.id === newProps.draggable.id)
      if (_.isEmpty(isAssetPresent)) {
        bucketItems = bucketItems && bucketItems.length ? bucketItems : []
        bucketItems.splice(newProps.destinationIndex, 0, tempAsset)
        bucketListDetails.bucketItems = bucketItems
        this.setState({
          bucketDetails: bucketListDetails,
          entities: this.loadBucketDetailsTolistData(bucketListDetails)
        })
        this.props.createBucketItem({ bucketItems: [buckets] }).then((response) => {
          this.props.updateHistory()
          const index = bucketItems.findIndex((item) => item.id === tempAsset.id)
          bucketItems[index] = response.data.batchCreateBucketItem[0]
          bucketItems = bucketItems.map((item, index) => {
            item.position = index >= newProps.destinationIndex ? index : item.position
            delete (item.__typename)
            return item
          })
          bucketListDetails.bucketItems = bucketItems
          this.setState({
            bucketDetails: bucketListDetails,
            entities: this.loadBucketDetailsTolistData(bucketListDetails)
          }, () => {
            // /* DISABLED AUTO SAVE */
            // if (bucketListDetails.status === 'DRAFT') { this.saveBucket(true) } else {
            //   this.props.changeBucket(bucketListDetails.id, true)
            //   this.setState({ isSaveEnable: true })
            // }
            this.props.changeBucket(bucketListDetails.id, true)
            this.setState({ isSaveEnable: true })
          })
          this.props.clearDragDropId()
        }, error => {
          // this.setState({ isSaveEnable: true })
          // utilityService.handleError(error)
          this.getBucket(error)
        })
      } else {
        message.warning(userMessages.ASSET_ADDED_ALREADY)
      }
    }

    if (newProps.droppableId && !newProps.draggable && !this.state.saveLoading) {
      let { bucketDetails, entities, selectedTaskIds } = this.state
      // let buckets = bucketDetails.bucketItems && bucketDetails.bucketItems.length ? [...bucketDetails.bucketItems] : []
      // const smallIndex = newProps.sourceIndex <= newProps.destinationIndex ? newProps.sourceIndex : newProps.destinationIndex
      // const largeIndex = newProps.sourceIndex === smallIndex ? newProps.destinationIndex : newProps.sourceIndex
      // buckets = this.getSortedList(buckets)
      // this.changedBucketItem.push(buckets[newProps.sourceIndex].id)
      // buckets = reorder(buckets, newProps.sourceIndex, newProps.destinationIndex)
      // buckets = buckets.map((item, index) => {
      //   item.position = (index >= smallIndex && index <= largeIndex) ? index : item.position
      //   return item
      // })
      // bucketDetails.bucketItems = buckets
      if (bucketDetails && bucketDetails.bucketItems && bucketDetails.bucketItems[newProps.sourceIndex] && selectedTaskIds && selectedTaskIds.length && selectedTaskIds.length > 0 && bucketDetails && !selectedTaskIds.includes(bucketDetails.bucketItems[newProps.sourceIndex].id)) {
        this.setState({ selectedTaskIds: [] })
        selectedTaskIds = []
      }
      if (bucketDetails && bucketDetails.bucketItems && bucketDetails.bucketItems[newProps.sourceIndex] && !this.changedBucketItem.includes(bucketDetails.bucketItems[newProps.sourceIndex].id)) {
        this.changedBucketItem.push(bucketDetails.bucketItems[newProps.sourceIndex].id) // for audit of single drag
      }
      selectedTaskIds.forEach((id) => {
        if (!this.changedBucketItem.includes(id)) {
          this.changedBucketItem.push(id)// for audit of multiple drag
        }
      })
      const destination = {
        index: newProps.destinationIndex,
        droppableId: '#Bucket_' + newProps.droppableId
      }
      const source = {
        index: newProps.sourceIndex,
        droppableId: '#Bucket_' + newProps.droppableId
      }
      let invalidOperation = false
      if (selectedTaskIds && selectedTaskIds.length > 1 && entities) {
        (selectedTaskIds || []).map(taskId => {
          const columnTemp = this.getHomeColumn(entities, taskId)
          if (columnTemp && columnTemp.taskIds) {
            const index = columnTemp.taskIds.indexOf(taskId)
            if (destination.index === index) {
              message.warn('Operation is not allowed')
              invalidOperation = true
            }
          }
        })
      }
      if (!invalidOperation || invalidOperation === false) {
        let tempEntities = _.cloneDeep(entities)
        const processed = multiDragAwareReorder({
          entities: tempEntities,
          selectedTaskIds: selectedTaskIds,
          source,
          destination
        })
        console.log('details', {
          entities: tempEntities,
          selectedTaskIds: selectedTaskIds,
          source,
          destination
        })
        console.log('processed', processed)
        console.log('newProps', newProps.droppableId)
        if (processed && processed.entities) {
          const selectedIds = processed.entities.columns['#Bucket_' + newProps.droppableId].taskIds
          let newArray = []
          selectedIds.forEach((selectedId, index) => {
            for (var [key, values] of Object.entries(processed.entities.tasks)) {
              if (key === selectedId) {
                values.position = index
                newArray.push(values)
              }
            }
          })
          const listData = [
            ...newArray
          ]
          console.log('listData', listData)

          if (!_.isEqual(listData, bucketDetails.bucketItems)) {
            bucketDetails.bucketItems = listData
            this.setState({ bucketDetails }, () => {
            // /* DISABLED AUTO SAVE */
            // if (bucketDetails.status === 'DRAFT') { this.saveBucket(true) } else {
            //   this.props.changeBucket(bucketDetails.id, true)
            //   this.setState({ isSaveEnable: true })
            // }
              this.props.changeBucket(bucketDetails.id, true)
              this.setState({
                entities: processed.entities,
                draggingTaskId: null,
                selectedTaskIds: [],
                isSaveEnable: true
              })
            })
            this.props.clearDragDropId()
          }
        }
      } else {
        this.setState(
          { draggingTaskId: null,
            selectedTaskIds: [],
            isSaveEnable: true }
        )
      }
    }
    if (newProps.forceFetchSubscription && !_.isEqual(newProps.forceFetchSubscription, this.props.forceFetchSubscription)) {
      this.props.fetchMoreBucketDetails().then(({ data }) => {
        this.props.completedSubscription(newProps.bucketId)
      })
    }
  }

  getHomeColumn = (entities, taskId) => {
    if (entities) {
      const columnId = entities.columnOrder.find((id) => {
        const column = entities.columns[id]
        return column.taskIds.includes(taskId)
      })

      // invariant(columnId, 'Count not find column for task')

      return entities.columns[columnId]
    }
  }

  initiateSubscription = () => {
    if (this.props.subscribeToChangeBucket) {
      // this.props.subscribeToChangeBucket()
    } else {
      setTimeout(() => {
        this.initiateSubscription()
      }, 1500)
    }
  }

  getObjectDiff = (obj1, obj2) => {
    const diff = Object.keys(obj1).reduce((result, key) => {
      if (!obj2.hasOwnProperty(key)) {
        result.push(key)
      } else if (_.isEqual(obj1[key], obj2[key])) {
        const resultKeyIndex = result.indexOf(key)
        result.splice(resultKeyIndex, 1)
      }
      return result
    }, Object.keys(obj2))

    return diff
  }

  isPropsSame = (newProps, oldProps) => {
    if (_.isEqual(newProps, oldProps)) {
      return true
    }
    const isPropDetailsSame = _.isEqual(newProps.isForceSave, oldProps.isForceSave) &&
                              _.isEqual(newProps.bucketListData, oldProps.bucketListData) &&
                              _.isEqual(newProps.bucketDetails, oldProps.bucketDetails) &&
                              _.isEqual(newProps.bucketId, oldProps.bucketId) &&
                              _.isEqual(newProps.id, oldProps.id) &&
                              _.isEqual(newProps.draggable, oldProps.draggable) &&
                              _.isEqual(newProps.droppableId, oldProps.droppableId) &&
                              _.isEqual(newProps.destinationIndex, oldProps.destinationIndex) &&
                              _.isEqual(newProps.sourceIndex, oldProps.sourceIndex) &&
                              _.isEqual(newProps.displayTypes, oldProps.displayTypes) &&
                              _.isEqual(newProps.isCreateBlocked, oldProps.isCreateBlocked) &&
                              _.isEqual(newProps.isUpdateBlocked, oldProps.isUpdateBlocked) &&
                              _.isEqual(newProps.isDeleteBlocked, oldProps.isDeleteBlocked)
    return isPropDetailsSame
  }

  getUserDetails = async () => {
    const userDetails = await AuthService.getUserDetails()
    if (userDetails) {
      this.username = userDetails.name || userDetails.email
    }
  }

  getAddFilterStatus = () => {
    let { bucketDetails } = this.state
    let bucketItems = bucketDetails ? _.cloneDeep(bucketDetails.bucketItems) : []
    const filterCount = (bucketItems || []).filter((item) => item.type === 'FILTER').length
    return filterCount >= 3
  }

  onBucketVersionAddSearch = async (versionId, newFilterItem) => {
    const { version, ...otherFilterDetails } = newFilterItem
    const {
      bucketDetails
      // updatedVersionBucketItems
    } = this.state
    // let updateDetails = cloneDeep(updatedVersionBucketItems)
    let versionIndex = null
    let newBucketDetails = {
      ...bucketDetails,
      versions: bucketDetails.versions.map((versionItem, index) => {
        if (versionItem.id === versionId) {
          versionIndex = index
          const copyOfVersion = cloneDeep(versionItem)
          const bucketItems = copyOfVersion?.bucketItems
          bucketItems.push(otherFilterDetails)
          this.updateEntitiesAndClearSelection(bucketItems, versionId)
          return copyOfVersion
        }
        return versionItem
      })
    }
    this.setState({ isScroll: true, bucketDetails: newBucketDetails })
    try {
      const { id, ...rest } = cloneDeep(newFilterItem)
      rest.version = version
      const response = await this.props.createBucketItem({ bucketItems: [{ ...rest }] })
      const newBucketId = response?.data?.batchCreateBucketItem?.[0]?.id
      // last item will be the new filter added
      const bucketItemsInVersion = newBucketDetails.versions?.[versionIndex]?.bucketItems
      const lastItem = bucketItemsInVersion?.[bucketItemsInVersion?.length - 1]
      // const filterForUpdateItem = this.getBucketItemStructureForSaveRequest(lastItem, this.state.bucketDetails.id)
      // console.log('filterForUpdateItem', filterForUpdateItem)
      // delete filterForUpdateItem?.version
      // console.log('filterForUpdateItem',filterForUpdateItem);
      // const existing = updateDetails?.[versionId] || []
      // updateDetails = {
      //   ...updateDetails,
      //   [versionId]: [...existing ]
      // }
      if (lastItem?.id) lastItem.id = newBucketId
      this.props.updateHistory()
      this.props.changeAddSearchStatusStatus(true)
      const newVersions = getSortedBucketItemsInsideVersion(newBucketDetails?.versions || [])
      newBucketDetails = {
        ...newBucketDetails,
        versions: newVersions
      }
      let copyOfBucketDetailsForComparison = cloneDeep(this.state.bucketDetailsForComparison)
      copyOfBucketDetailsForComparison = {
        ...copyOfBucketDetailsForComparison,
        versions: newVersions
      }
      this.setState({
        // updatedVersionBucketItems: updateDetails,
        bucketDetails: newBucketDetails,
        entities: this.loadBucketDetailsTolistData(newBucketDetails),
        addFilterLoading: false,
        bucketDetailsForComparison: copyOfBucketDetailsForComparison
      }, () => {
        this.props.changeBucket(bucketDetails.id, true)
        this.setState({ isSaveEnable: true })
      })
    } catch (err) {
      utilityService.handleError(err)
    }
  }

  onAddSearch = (versionId) => {
    this.setState({ addFilterLoading: true, isSaveEnable: false })
    const { bucketId } = this.props
    let { bucketDetails, updatedBucketItem } = this.state
    let { bucketItems: bucketItemsData } = bucketDetails
    let bucketItems = cloneDeep(bucketItemsData)
    bucketItems = bucketItems && bucketItems.length ? bucketItems : []
    const tempId = getUuid(bucketId + 'tempId123')
    const newData = {
      id: tempId,
      type: 'FILTER',
      bucket: bucketId,
      position: bucketItems.length,
      filterRule: {
        searchKey: null,
        filters: [
          {
            displayName: null,
            displayValue: 'isArchived',
            fieldName: 'isArchived',
            isRequired: null,
            name: 'isArchived',
            type: 'BOOLEAN',
            value: 'false'
          }, {
            displayName: null,
            displayValue: null,
            fieldName: 'updatedAt',
            isRequired: null,
            name: 'Sort',
            type: 'SORT',
            value: 'desc'
          }, {
            displayName: 'Limit',
            displayValue: null,
            fieldName: null,
            isRequired: true,
            name: 'limit',
            type: 'LIMIT',
            value: '10'
          }
        ]
      }
    }
    // if version id is passed it means user is trying to crease search on a version
    if (versionId) {
      let versionData = bucketDetails?.versions?.find(versionItem => versionItem.id === versionId)
      let bucketItems = versionData?.bucketItems || []
      newData.version = versionId
      newData.position = bucketItems?.length || 0
      this.onBucketVersionAddSearch(versionId, newData)
    } else {
      bucketItems.push(newData)
      bucketDetails.bucketItems = bucketItems
      this.setState({ bucketDetails, isScroll: true })
      const { id, ...rest } = newData
      this.props.changeAddSearchStatusStatus(false)
      this.props.createBucketItem({ bucketItems: [{ ...rest }] }).then((response) => {
        this.props.updateHistory()
        this.props.changeAddSearchStatusStatus(true)
        updatedBucketItem.push(response.data.batchCreateBucketItem[0].id)
        bucketItems[bucketItems.length - 1].id = response.data.batchCreateBucketItem[0].id
        bucketDetails.bucketItems = bucketItems
        this.setState({
          bucketDetails,
          entities: this.loadBucketDetailsTolistData(bucketDetails),
          addFilterLoading: false,
          updatedBucketItem
        }, () => {
        // /* DISABLED AUTO SAVE */
        // if (bucketDetails.status === 'DRAFT') {
        //   this.saveBucket(true)
        // } else {
        //   this.props.changeBucket(bucketDetails.id, true)
        //   this.setState({ isSaveEnable: true })
        // }
          this.props.changeBucket(bucketDetails.id, true)
          this.setState({ isSaveEnable: true })
        })
      }, error => {
      // this.setState({ isSaveEnable: true })
        this.getBucket(error)
      // utilityService.handleError(error)
      })
    }
  }

  checkForFilterChange = (id, value) => {
    const { bucketItems } = this.props.bucketDetails
    const currentItem = bucketItems.find(item => item.id === id)
    if (currentItem) {
      let filterRule = currentItem.filterRule
      delete (filterRule.__typename)
      filterRule.filters = (filterRule.filters || []).map((item) => {
        if (item.__typename) { delete (item.__typename) }
        return item
      })
      value.filters = value.filters.map((item) => {
        if (item.__typename) { delete (item.__typename) }
        return item
      })
      return !_.isEqual(filterRule, value)
    } else return true
  }

  onBucketVersionChangeFilter = (id, value, bucketVersionItem) => {
    const { bucketDetails, updatedVersionBucketItems } = this.state
    const isFilterChanged = this.checkForFilterChange(id, value)
    let updateDetails = cloneDeep(updatedVersionBucketItems)
    const copyOfBucketDetails = cloneDeep(bucketDetails)
    const { versions } = copyOfBucketDetails
    versions.forEach(versionItem => {
      if (versionItem.id === bucketVersionItem?.id) {
        const version = versionItem
        const bucketItems = version.bucketItems
        const modifiedIndex = bucketItems.findIndex(item => item.id === id)
        const bucketItem = bucketItems[modifiedIndex]
        bucketItem.filterRule = value
        const changedBucketItem = this.getBucketItemStructureForSaveRequest(bucketItem, bucketDetails.id)
        updateDetails = {
          ...updateDetails,
          [versionItem.id]: changedBucketItem
        }
      }
    })
    this.setState({
      bucketDetails: copyOfBucketDetails,
      isSaveEnable: this.state.isSaveEnable || isFilterChanged,
      updatedVersionBucketItems: updateDetails
    }, () => {
      this.props.changeBucket(bucketDetails.id, true)
    })
    // if (!isFilterChanged) {
    //   updatedBucketItem = updatedBucketItem.filter((item) => item !== id)
    //   const isSaveEnable = updatedBucketItem.length !== 0
    //   this.setState({ updatedBucketItem, isSaveEnable })
    // }
  }

  onChangeFilter = (id, value, actionType, bucketVersionItem) => {
    if (actionType === ACTION_TYPES.ACTION_ON_BUCKET_VERSION) {
      this.onBucketVersionChangeFilter(id, value, bucketVersionItem)
    } else {
      const isFilterChanged = this.checkForFilterChange(id, value)
      let { bucketDetails, updatedBucketItem } = this.state
      let { bucketItems } = this.state.bucketDetails
      const modifiedIndex = bucketItems.findIndex(item => item.id === id)
      bucketItems[modifiedIndex].filterRule = value
      bucketDetails.bucketItems = bucketItems
      if (updatedBucketItem.indexOf(id) === -1) { updatedBucketItem.push(id) }
      this.setState({ bucketDetails, updatedBucketItem, isSaveEnable: this.state.isSaveEnable || isFilterChanged }, () => {
      // /* DISABLED AUTO SAVE */
      // if (bucketDetails.status === 'DRAFT') {
      //   this.saveBucket(true)
      // } else {
      //   this.props.changeBucket(bucketDetails.id, true)
      // }
        this.props.changeBucket(bucketDetails.id, true)
      })
      if (!isFilterChanged) {
        updatedBucketItem = updatedBucketItem.filter((item) => item !== id)
        const isSaveEnable = updatedBucketItem.length !== 0
        this.setState({ updatedBucketItem, isSaveEnable })
      }
    }
  }

  handleCancel = () => {
    this.setState({ visible: false })
  }

  onBucketEditClick = () => {
    this.setState({ visible: true })
  }

  editBucket = editRequest => {
    this.setState({ loading: true })
    editRequest.id = this.props.bucketId
    editRequest.updatedAt = new Date().toISOString()
    editRequest.updatedBy = this.username
    userSessionId = utilityService.makeRandomString(6)
    sessionStorage.setItem('user_session_id', userSessionId)
    this.props.updateBucket(editRequest).then(response => {
      this.props.updateHistory()
      let { bucketDetails } = this.state
      const responseData = response.data.updateBucket
      bucketDetails.name = responseData.name
      bucketDetails.displayType = responseData.displayType
      bucketDetails.displayName = responseData.displayName
      this.setState({
        loading: false,
        visible: false,
        bucketDetails
      })
    }, error => {
      // this.setState({ loading: false })
      // utilityService.handleError(error)
      this.getBucket(error)
    })
  }

  deleteBucket = () => {

  }

  getBucket = (error) => {
    this.setState({ isModifiedLoading: true }, () => {
      this.props.fetchMoreBucketDetails().then(({ data }) => {
        if (error) { utilityService.handleError(error) }
        this.setState({
          bucketDetails: _.cloneDeep(data.getBucket),
          entities: this.loadBucketDetailsTolistData(_.cloneDeep(data.getBucket)),
          isModifiedLoading: false,
          isWarningShow: false,
          isSaveEnable: false,
          loading: false,
          saveLoading: false
        })
      })
    })
  }

  refetchBucketData = () => {
    this.setState({ isModifiedLoading: true }, () => {
      // this.props.fetchMoreBucketDetails().then(({ data }) => {
      // if (error) { utilityService.handleError(error) }
      this.props.forceSaveCompleted(this.state.tempBucketDetails.id)
      setTimeout(() => {
        this.setState({
          bucketDetails: _.cloneDeep(this.state.tempBucketDetails),
          entities: this.loadBucketDetailsTolistData(_.cloneDeep(this.state.tempBucketDetails)),
          isModifiedLoading: false,
          isWarningShow: false,
          isSaveEnable: false,
          loading: false,
          saveLoading: false,
          tempBucketDetails: null })
      }, 1000)
      // })
    })
  }

  getBucketVersionsStructure = (versions, { updatedVersionBucketItems, updatedVersionBucketItemsForTrackingMetaChanges }, bucketListItems) => {
    // const changed = {}
    // const old = this.state.bucketDetailsForComparison?.versions

    // old.forEach(versionItem => {
    //   const changedVersionItem = updatedVersionBucketItems?.[versionItem.id] || []
    //   const otherChangedItems = updatedVersionBucketItemsForTrackingMetaChanges?.[versionItem.id] || []
    //   if (!isEmpty(changedVersionItem) || !isEmpty(otherChangedItems)) {
    //     const oldBucketItems = cloneDeep(versionItem.bucketItems)
    //     const changedBucketItems = changedVersionItem
    //     changedBucketItems.forEach(changedBucketItem => {
    //       // takes up order changes

    //       const index = oldBucketItems?.findIndex(item => item.id === changedBucketItem.id)
    //       const oldBucketItem = oldBucketItems?.[index]
    //       console.log('oldBucketItem', oldBucketItem)
    //       const hasPositionChanged = (oldBucketItem?.position !== changedBucketItem?.position) && oldBucketItem?.position && changedBucketItem?.position
    //       if (hasPositionChanged || index === -1) {
    //         const newItem = this.getBucketItemStructureForSaveRequest(changedBucketItem, this.state.bucketDetails.id)
    //         const existing = changed?.[versionItem.id] || []
    //         changed[versionItem.id] = [...existing, newItem]
    //       }

    //       // changedBucketItems.forEach(changedBucketItem => {
    //       //   // if (oldBucketItem.id === changedBucketItem.id && oldBucketItem.position !== changedBucketItem.position) {
    //       //   if (oldBucketItem.id === changedBucketItem.id) {
    //       //     // when swapping position
    //       //     const hasPositionChanged = oldBucketItem.position !== changedBucketItem.position
    //       //     if (hasPositionChanged) {
    //       //       // console.log('changedBucketItem', { changedBucketItem, oldBucketItem })
    //       //       // changedBucketItem.trackPosChange = oldBucketItem?.trackPosChange || false
    //       //       const newItem = this.getBucketItemStructureForSaveRequest(changedBucketItem, this.state.bucketDetails.id)
    //       //       const existing = changed?.[versionItem.id] || []
    //       //       changed[versionItem.id] = [...existing, newItem]
    //       //     }
    //       //   }
    //       // })

    //       // // takes up anychanges other that oder changes
    //       // otherChangedItems.forEach(changedBucketItem => {
    //       //   if (oldBucketItem.id === changedBucketItem.id) {
    //       //     const hasTitleChanged = oldBucketItem?.customTitle !== changedBucketItem?.customTitle
    //       //     // console.log('hasTitleChanged', hasTitleChanged, changedBucketItem)
    //       //     if (hasTitleChanged) {
    //       //       const newItem = this.getBucketItemStructureForSaveRequest(changedBucketItem, this.state.bucketDetails.id)
    //       //       const existing = changed?.[versionItem.id] || []
    //       //       changed[versionItem.id] = [...existing, newItem]
    //       //     }
    //       //   }
    //       // })
    //     })
    //   }
    // })

    // console.log('changed', {
    //   changed: changed?.['921938cf-0b84-4362-a6f9-fe1854e0c728']?.map(item => {
    //     return {
    //       id: item.id,
    //       trackPosChange: item.trackPosChange,
    //       position: item.position
    //     }
    //   }).sort(function (a, b) {
    //     return a.id === b.id ? 0 : a.id < b.id ? -1 : 1
    //   }),
    //   bucketListItems: bucketListItems?.map(item => {
    //     return {
    //       id: item.id,
    //       trackPosChange: item.trackPosChange,
    //       position: item.position
    //     }
    //   }).sort(function (a, b) {
    //     return a.id === b.id ? 0 : a.id < b.id ? -1 : 1
    //   })
    // })

    const copyOfVersions = cloneDeep(versions) || []
    const versionsForParams = copyOfVersions.map(versionItem => {
      // const bucketItems = changed?.[versionItem?.id] || []
      const bucketItems = versionItem.bucketItems.map(item => {
        return this.getBucketItemStructureForSaveRequest(item, this.state.bucketDetails.id)
      })
      const bucket = versionItem.bucketItems.map(bucketItem => bucketItem.id)
      return {
        id: versionItem.id,
        // updatedAt: new Date().toISOString(),
        // updatedBy: this.username,
        bucketItems,
        bucket,
        name: versionItem.name
        // bucketItems: [],
        // bucket: []
      }
    })
    return versionsForParams
  }

  saveBucket = async (isAutoSave, isFromDelete) => {
    if (this.state.isSaveEnable) {
      this.props.onSave(this.props.bucketId)
      const { isUpdateBlocked } = this.props
      if (isUpdateBlocked) { return }
      this.setState({ saveLoading: true })
      // let isLatest = false
      // // await this.props.fetchBucketDetails().then(({ data }) => {
      // //   const { bucketDetails } = this.state
      // //   isLatest = moment(data.getBucket.updatedAt).isAfter(moment(bucketDetails.updatedAt), 'seconds')
      // // })
      // if (isLatest) {
      //   this.setState({ isWarningShow: true, saveLoading: false })
      // } else {
      const { bucketId } = this.props
      const { updatedVersionBucketItems, updatedVersionBucketItemsForTrackingMetaChanges } = this.state
      let { bucketItems, versions } = this.state.bucketDetails
      userSessionId = utilityService.makeRandomString(6)
      sessionStorage.setItem('user_session_id', userSessionId)
      const assetList = (bucketItems || []).filter((item) => item.type === 'ASSET').map((item) => {
        const isImagePresent = (!item.customAssetImage && item.customMedia) ? (item.images || []).find(imageItem => imageItem.mediaId === item.customMedia.id) : null
        return {
          id: item.id,
          position: item.position,
          assetId: item.asset ? item.asset.id : null,
          type: item.type,
          customMedia: item.customAssetImage ? item.customAssetImage.mediaId : (item.customMedia && isImagePresent) ? item.customMedia.id : null,
          customAssetImage: item.customAssetImage ? item.customAssetImage.id : null,
          customTitle: item.customTitle,
          bucket: bucketId
        }
      })
      const filterList = (bucketItems || []).filter((item) => item.type === 'FILTER').map((item) => {
        return {
          bucket: bucketId,
          position: item.position,
          type: item.type,
          id: item.id,
          filterRule: {
            searchKey: item.filterRule.searchKey,
            filters: (item.filterRule && item.filterRule.filters && item.filterRule.filters.length ? item.filterRule.filters : []).map((filterItem) => {
              if (filterItem.type === 'KEYWORD' || filterItem.type === 'SELECT') {
                if (typeof (filterItem.value) !== 'string') {
                  let value = (filterItem.value || []).map((filterInner) => filterInner.key)
                  let key = (filterItem.value || []).map((filterInner) => filterInner.name)
                  filterItem.value = value && value.length ? value.join() : null
                  filterItem.displayValue = key && key.length ? key.join() : null
                }
              }
              if (filterItem.type === 'MULTIPLE' || filterItem.name === 'metaValue') {
                if (typeof item.value === 'string' && item.value.startsWith('[')) {
                  filterItem.value = filterItem.value.slice(1, -1)
                } else if (typeof filterItem.value !== 'string') {
                  filterItem.value = filterItem.value && filterItem.value.length && filterItem.value.join(',')
                }
              }
              delete (filterItem.__typename)
              return filterItem
            })
          }
        }
      })
      let bucketListItems = [...assetList, ...filterList]
      bucketListItems = bucketListItems && bucketListItems.length ? bucketListItems : null
      let bucketIdList = bucketListItems && bucketListItems.length ? bucketListItems.map((item) => item.id) : null
      if (isFromDelete || !bucketListItems) {
        const variables = {
          id: bucketId,
          buckets: bucketIdList,
          updatedAt: new Date().toISOString(),
          updatedBy: this.username
        }
        const updatedBucketItems = this.getSortedList(_.cloneDeep(this.state.bucketDetails.bucketItems || []))
        bucketListItems = (bucketListItems || []).map(bucketItem => {
          const itemIndex = updatedBucketItems.findIndex(item => item.id === bucketItem.id)
          if (itemIndex > -1) {
            bucketItem.position = itemIndex
          }
          return bucketItem
        })
        let updatedBucketListItems = _.cloneDeep(this.props.bucketDetails.bucketItems || [])
        bucketListItems = (bucketListItems || []).filter(item => {
          const tempIndex = updatedBucketListItems.findIndex(innerItem => innerItem.id === item.id)
          const isEdited = this.state.updatedBucketItem.indexOf(item.id) > -1
          return isEdited || tempIndex === -1 || updatedBucketListItems[tempIndex].position !== item.position
        })
        const versionsForParams = this.getBucketVersionsStructure(versions, { updatedVersionBucketItems, updatedVersionBucketItemsForTrackingMetaChanges }, bucketListItems)
        this.updatedBucketItemAndUpdateBucket(bucketListItems, variables, isAutoSave, versionsForParams)
        // if (bucketListItems.length) {
        //   const versionsForParams = this.getBucketVersionsStructure(versions, { updatedVersionBucketItems, updatedVersionBucketItemsForTrackingMetaChanges }, bucketListItems)
        //   this.updatedBucketItemAndUpdateBucket(bucketListItems, variables, isAutoSave, versionsForParams)
        //   console.warn('##### 11 VERSIONS NOT PASSED #####')
        // } else {
        //   this.updateBucket(variables, isAutoSave)
        //   console.warn('##### 22 VERSIONS NOT PASSED #####')
        // }
      } else {
        bucketListItems = bucketListItems && bucketListItems.length ? bucketListItems : null
        const variables = {
          id: bucketId,
          buckets: bucketIdList,
          updatedAt: new Date().toISOString(),
          updatedBy: this.username
        }
        bucketListItems = (bucketListItems || []).map(item => {
          const isAuditChange = this.changedBucketItem.includes(item.id)
          item.trackPosChange = isAuditChange
          return item
        })
        const updatedBucketItems = this.getSortedList(_.cloneDeep(this.state.bucketDetails.bucketItems))
        bucketListItems = bucketListItems.map(bucketItem => {
          const itemIndex = updatedBucketItems.findIndex(item => item.id === bucketItem.id)
          if (itemIndex > -1) {
            bucketItem.position = itemIndex
          }
          return bucketItem
        })
        let updatedBucketListItems = _.cloneDeep(this.props.bucketDetails.bucketItems || [])
        bucketListItems = (bucketListItems || []).filter(item => {
          const tempIndex = updatedBucketListItems.findIndex(innerItem => innerItem.id === item.id)
          const isEdited = this.state.updatedBucketItem.indexOf(item.id) > -1
          // console.log('order', {
          //   // postion: updatedBucketListItems[tempIndex].position,
          //   // itempos: item.position,
          //   item,
          //   up: updatedBucketListItems[tempIndex]
          // })
          return isEdited || tempIndex === -1 || updatedBucketListItems[tempIndex].position !== item.position
        })
        const versionsForParams = this.getBucketVersionsStructure(versions, { updatedVersionBucketItems, updatedVersionBucketItemsForTrackingMetaChanges }, bucketListItems)
        this.updatedBucketItemAndUpdateBucket(bucketListItems, variables, isAutoSave, versionsForParams)

        // if (bucketListItems) {
        //   this.updatedBucketItemAndUpdateBucket(bucketListItems, variables, isAutoSave, versionsForParams)
        // } else {
        //   this.updateBucket(variables, isAutoSave)
        // }
      }
      if (this.props.isForceSave) { this.props.forceSaveCompleted(this.props.bucketId) }
    }
  }

  updatedBucketItemAndUpdateBucket = (bucketListItems, variables, isAutoSave, versionsForParams) => {
    const { bucketId } = this.props
    variables.bucketItems = variables.buckets
    delete variables.buckets
    // console.log('params', { bucketItems: bucketListItems, bucket: variables, id: bucketId, versions: versionsForParams })
    // return
    // this.props.updateBucketItem(bucketListItems).then(() => {
    //   this.props.updateBucket(variables).then(({ data }) => {
    this.props.saveAllBuckets({ bucketItems: bucketListItems, bucket: variables, id: bucketId, versions: versionsForParams }).then(({ data }) => {
      this.props.changeBucket(bucketId, false)
      this.changedBucketItem = []
      let copyOfResponse = cloneDeep(data.saveAllBuckets)
      const sortedData = this.getSortedList(cloneDeep(copyOfResponse?.bucketItems)) || []
      // if (!copyOfResponse?.versions) {
      //   console.error('Response')
      // }
      const newVersions = getSortedBucketItemsInsideVersion(copyOfResponse?.versions || [])
      copyOfResponse = {
        ...copyOfResponse,
        bucketItems: sortedData,
        versions: newVersions
      }
      this.setState({ isSaveEnable: false, saveLoading: false, bucketDetails: copyOfResponse, updatedVersionBucketItems: {}, versionBucketItemsOrderTracker: [] })
      if (!isAutoSave) { message.success(userMessages.BUCKET_UPDATED_SUCCESS) }
      this.props.updateHistory()
    }, error => {
      // this.setState({ saveLoading: false })
      // utilityService.handleError(error)
      this.getBucket(error)
    })
    // }, error => {
    //   // utilityService.handleError(error)
    //   this.getBucket(error)
    // })
  }

  updateBucket = (variables, isAutoSave) => {
    const { bucketId } = this.props
    this.props.updateBucket(variables).then(({ data }) => {
      this.props.changeBucket(bucketId, false)
      this.setState({ isSaveEnable: false, saveLoading: false, updatedBucketItem: [], bucketDetails: data.updateBucket })
      if (!isAutoSave) { message.success(userMessages.BUCKET_UPDATED_SUCCESS) }
      this.props.updateHistory()
    }, error => {
      // this.setState({ saveLoading: false })
      // utilityService.handleError(error)
      this.getBucket(error)
    })
  }

  copyLink = () => {
    var anchor = document.createElement('a')
    anchor.href = `${location.origin}/buckets/preview/${this.props.bucketId}`
    anchor.target = '_blank'
    document.body.appendChild(anchor)
    anchor.click()
  }

  toggleDeleteeWarningMessage = (status) => {
    this.setState({ showWarning: status })
  }

  removeVersionBucketItem = (itemId, bucketVersionItem) => {
    console.log('details', { itemId, bucketVersionItem })
    // const { bucketVersionItem, getParentState, setParentState, bucketId } = this.props
    const { bucketDetails } = this.state
    const bucketId = bucketDetails?.id
    const newBucketDetails = {
      ...bucketDetails,
      versions: bucketDetails.versions.map(versionItem => {
        if (versionItem.id === bucketVersionItem.id) {
          const newBucketItemsInVersion = cloneDeep(bucketVersionItem?.bucketItems).filter(bucketItem => {
            console.log('bucketItem', { id: bucketItem.id, itemId, cn: bucketItem.id !== itemId })
            return bucketItem.id !== itemId
          })
          // console.log('newBucketItemsInVersionn',newBucketItemsInVersion);
          const positionUpdatedList = this.positionAdjuster(newBucketItemsInVersion)
          const copyOfVersion = cloneDeep(versionItem)
          // console.log('positionUpdatedList',positionUpdatedList);
          copyOfVersion.bucketItems = positionUpdatedList
          return copyOfVersion
        }
        return versionItem
      })
    }
    this.setState({
      bucketDetails: newBucketDetails,
      isSaveEnable: true,
      selectedTaskIdsInsideVersions: []
    })
    this.props.changeBucket(bucketId, true)
  }

  removeBucketItem = (itemId, actionType, currentActiveBucketVersion) => {
    if (actionType === ACTION_TYPES.ACTION_ON_BUCKET_VERSION) {
      this.removeVersionBucketItem(itemId, currentActiveBucketVersion)
    } else {
      let { bucketDetails, updatedBucketItem, selectedTaskIds } = this.state
      let { bucketItems } = bucketDetails
      const deletedIndex = bucketItems.findIndex((item) => item.id === itemId)
      bucketItems = bucketItems.filter((item) => item.id !== itemId).map((item, index) => {
        if (deletedIndex <= index && updatedBucketItem.indexOf(item.id) === -1) {
          updatedBucketItem.push(item.id)
        }
        item.position = index
        return item
      })
      bucketDetails.bucketItems = bucketItems && bucketItems.length ? bucketItems : null
      let filterSelectedTaskIds = (selectedTaskIds || []).filter(item => item !== itemId)
      this.setState({
        bucketItems,
        entities: this.loadBucketDetailsTolistData(_.cloneDeep(bucketDetails)),
        updatedBucketItem,
        selectedTaskIds: filterSelectedTaskIds
      }, () => {
      // /* DISABLED AUTO SAVE */
      // if (bucketDetails.status === 'DRAFT') { this.saveBucket(true, true) } else {
      //   this.props.changeBucket(bucketDetails.id, true)
      //   this.setState({ isSaveEnable: true })
      // }
        this.props.changeBucket(bucketDetails.id, true)
        this.setState({ isSaveEnable: true })
      })
    }
  }
  // itemId, currentActiveBucketVersion, currentActiveBucketVersion.id

  attachChangedItem = (existing, newItem, key, value) => {
    const copyOfExisting = cloneDeep(existing)
    let hasUpdatedExistingEntry = false
    copyOfExisting.forEach(existingItem => {
      if (existingItem.id === newItem.id) {
        hasUpdatedExistingEntry = true
        existingItem[key] = value
      }
    })
    const newDetails = hasUpdatedExistingEntry ? copyOfExisting : [...copyOfExisting, newItem]
    return newDetails
  }
  onBucketVersionAssetTitleChange = (title, id, bucketVersionItem) => {
    const versionId = bucketVersionItem.id
    const {
      bucketDetails
      // updatedVersionBucketItemsForTrackingMetaChanges, updatedVersionBucketItems
    } = this.state
    // let copyOfUpdatedVersionBucketItemsForTrackingMetaChanges = cloneDeep(updatedVersionBucketItemsForTrackingMetaChanges)
    // let copyOfUpdatedVersionBucketItems = cloneDeep(updatedVersionBucketItems)
    // let updateDetails = cloneDeep(updatedVersionBucketItems)
    const newBucketDetails = {
      ...bucketDetails,
      versions: bucketDetails.versions.map(versionItem => {
        if (versionItem.id === versionId) {
          const copyOfVersion = cloneDeep(bucketVersionItem)
          const bucketItems = copyOfVersion?.bucketItems
          const index = bucketItems.findIndex(bucketItem => bucketItem.id === id)
          if (index !== -1) {
            const bucketItem = bucketItems[index]
            bucketItem.customTitle = title
            // const newItem = this.getBucketItemStructureForSaveRequest(bucketItem, bucketDetails.id)
            // const a = this.attachChangedItem(copyOfUpdatedVersionBucketItemsForTrackingMetaChanges?.[versionId] || [], newItem, 'customTitle', title)
            // const b = this.attachChangedItem(copyOfUpdatedVersionBucketItems?.[versionId] || [], newItem, 'customTitle', title)
            // copyOfUpdatedVersionBucketItemsForTrackingMetaChanges = {
            //   ...copyOfUpdatedVersionBucketItemsForTrackingMetaChanges,
            //   [versionId]: a
            // }
            // copyOfUpdatedVersionBucketItems = {
            //   ...copyOfUpdatedVersionBucketItems,
            //   [versionId]: b
            // }
          }
          return copyOfVersion
        }
        return versionItem
      })
    }
    this.setState({
      bucketDetails: newBucketDetails,
      isSaveEnable: true
      // updatedVersionBucketItemsForTrackingMetaChanges: copyOfUpdatedVersionBucketItemsForTrackingMetaChanges,
      // updatedVersionBucketItems: copyOfUpdatedVersionBucketItems
    })
    this.props.changeBucket(bucketDetails.id, true)
  }

  onAssetTitleChange = (title, id, actionType, currentActiveBucketVersion) => {
    if (actionType === ACTION_TYPES.ACTION_ON_BUCKET_VERSION) {
      this.onBucketVersionAssetTitleChange(title, id, currentActiveBucketVersion)
    } else {
      let { updatedBucketItem } = this.state
      let { bucketItems } = this.state.bucketDetails
      const bucketItemIndex = bucketItems.findIndex((item) => item.id === id)
      bucketItems[bucketItemIndex].customTitle = title
      if (updatedBucketItem.indexOf(id) === -1) {
        updatedBucketItem.push(id)
      }
      this.setState({ bucketItems, updatedBucketItem }, () => {
        // /* DISABLED AUTO SAVE */
        // if (this.state.bucketDetails.status === 'DRAFT') { this.saveBucket(true, false) } else {
        //   this.props.changeBucket(this.state.bucketDetails.id, true)
        //   this.setState({ isSaveEnable: true })
        // }
        this.props.changeBucket(this.state.bucketDetails.id, true)
        this.setState({ isSaveEnable: true })
      })
    }
  }
  // title, id, bucketVersionItem
  onBucketVersionAssetDisplayImageChange = (media, id, defaultMedia, bucketVersionItem) => {
    const versionId = bucketVersionItem.id
    const {
      bucketDetails
      //  updatedVersionBucketItems
    } = this.state
    // let updateDetails = cloneDeep(updatedVersionBucketItems)
    const newBucketDetails = {
      ...bucketDetails,
      versions: bucketDetails.versions.map(versionItem => {
        if (versionItem.id === versionId) {
          const copyOfVersion = cloneDeep(bucketVersionItem)
          const bucketItems = copyOfVersion?.bucketItems
          const bucketItemIndex = bucketItems.findIndex(item => item.id === id)
          if (bucketItemIndex !== -1) {
            const bucketItem = bucketItems[bucketItemIndex]
            bucketItems[bucketItemIndex].customAssetImage = media
            if (defaultMedia) {
              bucketItem.asset.defaultMedia = defaultMedia
            } else if (!media && !defaultMedia) {
              bucketItem.asset.defaultMedia = null
            }
            // updateDetails = {
            //   ...updateDetails,
            //   [versionId]: this.getBucketItemStructureForSaveRequest(bucketItem, bucketDetails.id)
            // }
          }
          return copyOfVersion
        }
        return versionItem
      })
    }

    this.setState({
      bucketDetails: newBucketDetails,
      isSaveEnable: true
      // updatedVersionBucketItems: updateDetails
    })
    this.props.changeBucket(bucketDetails.id, true)
  }

  onAssetDisplayImageChange = (media, id, defaultMedia, actionType, currentActiveBucketVersion) => {
    if (actionType === ACTION_TYPES.ACTION_ON_BUCKET_VERSION) {
      this.onBucketVersionAssetDisplayImageChange(media, id, defaultMedia, currentActiveBucketVersion)
    } else {
      let { updatedBucketItem } = this.state
      let { bucketItems } = this.state.bucketDetails
      const bucketItemIndex = bucketItems.findIndex((item) => item.id === id)
      bucketItems[bucketItemIndex].customAssetImage = media
      if (defaultMedia) {
        bucketItems[bucketItemIndex].asset.defaultMedia = defaultMedia
      } else if (!media && !defaultMedia) {
        bucketItems[bucketItemIndex].asset.defaultMedia = null
      }
      if (updatedBucketItem.indexOf(id) === -1) {
        updatedBucketItem.push(id)
      }
      this.setState({ bucketItems, updatedBucketItem }, () => {
      // /* DISABLED AUTO SAVE */
      // if (this.state.bucketDetails.status === 'DRAFT') { this.saveBucket(true, false) } else {
      //   this.props.changeBucket(this.state.bucketDetails.id, true)
      //   this.setState({ isSaveEnable: true })
      // }
        this.props.changeBucket(this.state.bucketDetails.id, true)
        this.setState({ isSaveEnable: true })
      })
    }
  }

  onBucketVersionAssetTitleReset = (id, bucketVersionItem) => {
    const versionId = bucketVersionItem.id
    const {
      bucketDetails
      //  updatedVersionBucketItemsForTrackingMetaChanges, updatedVersionBucketItems
    } = this.state
    // let copyOfUpdatedVersionBucketItemsForTrackingMetaChanges = cloneDeep(updatedVersionBucketItemsForTrackingMetaChanges)
    // let copyOfUpdatedVersionBucketItems = cloneDeep(updatedVersionBucketItems)
    const newBucketDetails = {
      ...bucketDetails,
      versions: bucketDetails.versions.map(versionItem => {
        if (versionItem.id === versionId) {
          const copyOfVersion = cloneDeep(bucketVersionItem)
          const bucketItems = copyOfVersion?.bucketItems
          const index = bucketItems.findIndex(bucketItem => bucketItem.id === id)
          const bucketItem = bucketItems[index]
          if (index !== -1) {
            bucketItem.customTitle = null
            // const newItem = this.getBucketItemStructureForSaveRequest(bucketItem, bucketDetails.id)
            // const a = this.attachChangedItem(copyOfUpdatedVersionBucketItemsForTrackingMetaChanges?.[versionId] || [], newItem, 'customTitle', null)
            // const b = this.attachChangedItem(copyOfUpdatedVersionBucketItems?.[versionId] || [], newItem, 'customTitle', null)
            // copyOfUpdatedVersionBucketItemsForTrackingMetaChanges = {
            //   ...copyOfUpdatedVersionBucketItemsForTrackingMetaChanges,
            //   [versionId]: a
            // }
            // copyOfUpdatedVersionBucketItems = {
            //   ...copyOfUpdatedVersionBucketItems,
            //   [versionId]: b
            // }
          }
          return copyOfVersion
        }
        return versionItem
      })
    }
    this.setState({
      bucketDetails: newBucketDetails,
      isSaveEnable: true
      // updatedVersionBucketItemsForTrackingMetaChanges: copyOfUpdatedVersionBucketItemsForTrackingMetaChanges,
      // updatedVersionBucketItems: copyOfUpdatedVersionBucketItems
    })
    this.props.changeBucket(bucketDetails.id, true)
  }

  onAssetTitleReset = (id, actionType, currentActiveBucketVersion) => {
    if (actionType === ACTION_TYPES.ACTION_ON_BUCKET_VERSION) {
      this.onBucketVersionAssetTitleReset(id, currentActiveBucketVersion)
    } else {
      let { updatedBucketItem } = this.state
      let { bucketItems } = this.state.bucketDetails
      const bucketItemIndex = bucketItems.findIndex((item) => item.id === id)
      bucketItems[bucketItemIndex].customTitle = null
      if (updatedBucketItem.indexOf(id) === -1) {
        updatedBucketItem.push(id)
      }
      this.setState({ bucketItems, updatedBucketItem }, () => {
      // /* DISABLED AUTO SAVE */
      // if (this.state.bucketDetails.status === 'DRAFT') { this.saveBucket(true, false) } else {
      //   this.props.changeBucket(this.state.bucketDetails.id, true)
      //   this.setState({ isSaveEnable: true })
      // }
        this.props.changeBucket(this.state.bucketDetails.id, true)
        this.setState({ isSaveEnable: true })
      })
    }
  }

  onBucketVersionAssetDisplayImageReset = (id, bucketVersionItem) => {
    const versionId = bucketVersionItem.id
    const {
      bucketDetails
      // updatedVersionBucketItems
    } = this.state
    // let updateDetails = cloneDeep(updatedVersionBucketItems)
    const newBucketDetails = {
      ...bucketDetails,
      versions: bucketDetails.versions.map(versionItem => {
        if (versionItem.id === versionId) {
          const copyOfVersion = cloneDeep(bucketVersionItem)
          const bucketItems = copyOfVersion?.bucketItems
          const index = bucketItems.findIndex(bucketItem => bucketItem.id === id)
          const bucketItem = bucketItems[index]
          if (index !== -1) {
            bucketItem.customMedia = null
            bucketItem.customAssetImage = null
            // updateDetails = {
            //   ...updateDetails,
            //   [versionId]: this.getBucketItemStructureForSaveRequest(bucketItem, bucketDetails.id)
            // }
          }
          return copyOfVersion
        }
        return versionItem
      })
    }
    this.setState({
      bucketDetails: newBucketDetails,
      isSaveEnable: true
      // updatedVersionBucketItems: updateDetails
    })
    this.props.changeBucket(bucketDetails.id, true)
  }

  onAssetDisplayImageReset = (id, actionType, currentActiveBucketVersion) => {
    if (actionType === ACTION_TYPES.ACTION_ON_BUCKET_VERSION) {
      this.onBucketVersionAssetDisplayImageReset(id, currentActiveBucketVersion)
    } else {
      let { updatedBucketItem } = this.state
      let { bucketItems } = this.state.bucketDetails
      const bucketItemIndex = bucketItems.findIndex((item) => item.id === id)
      bucketItems[bucketItemIndex].customMedia = null
      bucketItems[bucketItemIndex].customAssetImage = null
      if (updatedBucketItem.indexOf(id) === -1) {
        updatedBucketItem.push(id)
      }
      this.setState({ bucketItems, updatedBucketItem }, () => {
      // /* DISABLED AUTO SAVE */
      // if (this.state.bucketDetails.status === 'DRAFT') { this.saveBucket(true, false) } else {
      //   this.props.changeBucket(this.state.bucketDetails.id, true)
      //   this.setState({ isSaveEnable: true })
      // }
        this.props.changeBucket(this.state.bucketDetails.id, true)
        this.setState({ isSaveEnable: true })
      })
    }
  }

  onDragEnd = (startIndex, endIndex) => {
    let { listData } = this.state
    const [ removed ] = listData.splice(startIndex, 1)
    listData.splice(endIndex, 0, removed)
    this.setState({ listData })
  }

  getSortedList = (data) => {
    return (data || []).sort((a, b) => (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0))
  }

  showPublish = () => {
    this.setState({ showPublish: true })
  }

  handleCancel = () => {
    this.setState({ showPublish: false, visible: false })
  }

  onBucketScroll= () => {
    this.setState({ isScroll: false })
  }

  onMultiDrop = (data) => {
    let { bucketDetails } = this.state
    bucketDetails.bucketItems = data
    this.props.changeBucket(bucketDetails.id, true)
    this.setState({
      bucketDetails,
      isSaveEnable: true
    })
  }

  // ---------- Starts ::MULTISEELCT ON DEFAULT BUCKETITEM EXISTING CODE ----------

  toggleSelection = (taskId) => {
    const selectedTaskIds = this.state.selectedTaskIds
    const wasSelected = selectedTaskIds.includes(taskId)

    const newTaskIds = (() => {
      // Task was not previously selected
      // now will be the only selected item
      if (!wasSelected) {
        return [taskId]
      }

      // Task was part of a selected group
      // will now become the only selected item
      if (selectedTaskIds.length > 1) {
        return [taskId]
      }

      // task was previously selected but not in a group
      // we will now clear the selection
      return []
    })()
    this.setState({
      selectedTaskIds: newTaskIds,
      entities: this.state.entities
    })
  }

  toggleSelectionInGroup = (taskId) => {
    const selectedTaskIds = this.state.selectedTaskIds
    const index = selectedTaskIds.indexOf(taskId)

    // if not selected - add it to the selected items
    if (index === -1) {
      this.setState({
        selectedTaskIds: [...selectedTaskIds, taskId],
        entities: this.state.entities
      })
      return
    }

    // it was previously selected and now needs to be removed from the group
    const shallow = [...selectedTaskIds]
    shallow.splice(index, 1)
    this.setState({
      selectedTaskIds: shallow,
      entities: this.state.entities
    })
  }

  // This behaviour matches the MacOSX finder selection
  multiSelectTo = (newTaskId) => {
    const updated = multiSelect(
      this.state.entities,
      this.state.selectedTaskIds,
      newTaskId
    )
    if (updated == null) {
      return
    }
    this.setState({
      selectedTaskIds: updated,
      entities: this.state.entities
    })
  }
  // ---------- Ends ::MULTISEELCT ON DEFAULT BUCKETITEM EXISTING CODE ----------

  // ---------- Starts :: for versions ----------

  getSelectionDetailsForThisVersion = (newEntities, newTaskIds = [], versionId) => {
    // console.log('newEntities', newEntities)
    // console.log('newTaskIds', newTaskIds)
    const { entitiesInsideVersions: masterEntities, selectedTaskIdsInsideVersions: masterTaskIds } = this.getBucketDetailCellState()
    const copyOfMasterEntities = cloneDeep(masterEntities)
    const copyOfMasterTaskIds = cloneDeep(masterTaskIds)
    // const entities = entitiesInsideVersions || {}
    // const taskIds = selectedTaskIdsInsideVersions || []
    copyOfMasterEntities[versionId] = {
      // ...entities,
      ...(newEntities || {})
    }
    copyOfMasterTaskIds[versionId] = [
      // ...taskIds,
      ...(newTaskIds || [])
    ]
    // console.log('copyOfMasterEntities', copyOfMasterEntities)
    // console.log('copyOfMasterTaskIds', copyOfMasterTaskIds)
    return {
      selectedTaskIdsInsideVersions: copyOfMasterTaskIds,
      entitiesInsideVersions: copyOfMasterEntities
    }
  }

  // normal selection
 toggleSelectionOnVersions = (taskId, versionId) => {
   //  console.log('1111')
   const { selectedTaskIdsInsideVersions } = this.state
   const wasSelected = selectedTaskIdsInsideVersions.includes(taskId)

   const newTaskIds = (() => {
     // Task was not previously selected
     // now will be the only selected item
     if (!wasSelected) {
       return [taskId]
     }

     // Task was part of a selected group
     // will now become the only selected item
     if (selectedTaskIdsInsideVersions.length > 1) {
       return [taskId]
     }

     // task was previously selected but not in a group
     // we will now clear the selection
     return []
   })()

   const { selectedTaskIdsInsideVersions: newTaskIdData } = this.getSelectionDetailsForThisVersion(null, newTaskIds, versionId)
   //  console.log('newTaskIdData', newTaskIdData)
   this.handleBucketDetailCellState({
     selectedTaskIdsInsideVersions: newTaskIdData
     // entitiesInsideVersions: entitiesInsideVersions
   })
   // this.setState({
   //   selectedTaskIds: newTaskIds,
   //   entities: this.state.entities
   // })
 }
 //  ctrl key in windows
  toggleSelectionInGroupOnVersions = (taskId, versionId) => {
    // console.log('222', taskId, versionId)

    const { selectedTaskIdsInsideVersions: MasterSelectedTaskIdsInsideVersions } = this.state
    const selectedTaskIdsInsideVersions = MasterSelectedTaskIdsInsideVersions?.[versionId] || []

    const index = selectedTaskIdsInsideVersions.indexOf(taskId)

    // if not selected - add it to the selected items
    if (index === -1) {
      // this.setState({
      //   selectedTaskIds: [...selectedTaskIdsInsideVersions, taskId],
      //   entities: this.state.entities
      // })
      const { selectedTaskIdsInsideVersions: newTaskIdData } = this.getSelectionDetailsForThisVersion(null, [...selectedTaskIdsInsideVersions, taskId], versionId)
      // console.log('newTaskIdData', newTaskIdData)
      this.handleBucketDetailCellState({
        selectedTaskIdsInsideVersions: newTaskIdData
        // entitiesInsideVersions: entitiesInsideVersions
      })
      return
    }

    // it was previously selected and now needs to be removed from the group
    const shallow = [...selectedTaskIdsInsideVersions]
    shallow.splice(index, 1)
    // this.setState({
    //   selectedTaskIds: shallow,
    //   entities: this.state.entities
    // })
    const { selectedTaskIdsInsideVersions: newTaskIdData } = this.getSelectionDetailsForThisVersion(null, shallow)
    console.log('newTaskIdData', newTaskIdData)

    this.handleBucketDetailCellState({
      selectedTaskIdsInsideVersions: newTaskIdData
      // entitiesInsideVersions: entitiesInsideVersions
    })
  }

  // This behaviour matches the MacOSX finder selection, on shift key multi select in windows
  multiSelectToOnVersions = (newTaskId, versionId) => {
    const { selectedTaskIdsInsideVersions: MasterSelectedTaskIdsInsideVersions, entitiesInsideVersions: masterEntitiesInsideVersions } = this.state
    const selectedTaskIdsInsideVersions = MasterSelectedTaskIdsInsideVersions?.[versionId] || []
    const entitiesInsideVersions = masterEntitiesInsideVersions?.[versionId] || []

    const updated = multiSelect(entitiesInsideVersions, selectedTaskIdsInsideVersions, newTaskId)
    if (updated == null) {
      return
    }

    const { selectedTaskIdsInsideVersions: newTaskIdData } = this.getSelectionDetailsForThisVersion(null, updated, versionId)

    this.handleBucketDetailCellState({
      selectedTaskIdsInsideVersions: newTaskIdData
      // entitiesInsideVersions: entitiesInsideVersions
    })
    // this.setState({
    //   selectedTaskIds: updated,
    //   entities: this.state.entities
    // })
  }
  // ---------- Ends :: for versions ----------

  getVersionDetails = (bucketVersions = []) => {
    let scheduledVersions = []
    let currentActiveBucketVersion = null
    const copyOfBucketVersions = cloneDeep(bucketVersions)
    let reorderedVersions = copyOfBucketVersions
    let currentItemIndex = null
    bucketVersions.forEach((bucketVersion, i) => {
      if (bucketVersion.publishStartDate && bucketVersion.publishEndDate) {
        const currentTime = moment()
        const publishStartDate = moment(bucketVersion.publishStartDate)
        const publishEndDate = moment(bucketVersion.publishEndDate)
        // if published + if current time falls in between start date and end date
        if (currentTime.isBetween(publishStartDate, publishEndDate) && bucketVersion.isPublished) {
          currentActiveBucketVersion = bucketVersion
          currentItemIndex = i
        }
      }
      if (bucketVersion.isPublished && !isEmpty(bucketVersion.publishStartDate) && !isEmpty(bucketVersion.publishEndDate)) {
        scheduledVersions.push(bucketVersion)
      }
    })
    // if there is active version put it as first item
    if (currentActiveBucketVersion) {
      copyOfBucketVersions.splice(currentItemIndex, 1)
      copyOfBucketVersions.sort(function (versionA, versionB) {
        return moment(versionA.createdAt).format('X') - moment(versionB.createdAt).format('X')
      })
      reorderedVersions = [currentActiveBucketVersion, ...copyOfBucketVersions]
    } else {
      reorderedVersions.sort(function (versionA, versionB) {
        return moment(versionA.createdAt).format('X') - moment(versionB.createdAt).format('X')
      })
    }
    return {
      currentActiveBucketVersion,
      reorderedVersions,
      scheduledVersions
    }
  };

   positionAdjuster = (newBucketItems) => {
     const details = cloneDeep(newBucketItems)
     const newArray = details.map((item, index) => {
       return {
         ...item,
         position: index
       }
     })
     return newArray
   }

   // getUpdatedAssets = (oldBucketItems, repositionedBucketItems, bucketId) => {
   //   const changedArray = []
   //   oldBucketItems.forEach((item, index) => {
   //     const bucketItem = repositionedBucketItems.find(repoItem => repoItem.id === item.id)
   //     // console.log('order', {
   //     //   bucketItem,
   //     //   item
   //     // })
   //     // if id is not equal it means order has changed
   //     if (item.position !== bucketItem.position) {
   //       const changedBucketItem = this.getBucketItemStructureForSaveRequest(bucketItem, bucketId)
   //       changedArray.push(changedBucketItem)
   //     }
   //   })
   //   return changedArray
   // }

  getBucketItemStructureForSaveRequest = (bucketItem, bucketIdd, versionItem) => {
    // console.log('bucketItem', { bucketItem, versionItem })
    const { id: bucketItemId, asset: assetDetails, __typename, customAssetImage, customMedia, customTile, filterRule, isLoading, trackPosChange, ...others } = cloneDeep(bucketItem)
    let { __typename: filterTypeName, ...otherFilterItems } = cloneDeep(filterRule || {})
    const requestParams = {
      id: bucketItemId,
      assetId: assetDetails?.id,
      bucket: bucketIdd,
      trackPosChange: trackPosChange || false,
      // trackPosChange: true,
      customMedia: customAssetImage?.mediaId || null,
      customAssetImage: customAssetImage?.id || null,
      customTile: customTile ?? undefined,
      ...others
    }

    // only add filter if there is a search filter item in list
    if (bucketItem.type === 'FILTER') {
      otherFilterItems = {
        ...otherFilterItems,
        filters: otherFilterItems?.filters?.map((filterItem) => {
          if (filterItem.type === 'KEYWORD' || filterItem.type === 'SELECT') {
            if (typeof (filterItem.value) !== 'string') {
              let value = (filterItem.value || []).map((filterInner) => filterInner.key)
              let key = (filterItem.value || []).map((filterInner) => filterInner.name)
              filterItem.value = value && value.length ? value.join() : null
              filterItem.displayValue = key && key.length ? key.join() : null
            }
          }
          if (filterItem.type === 'MULTIPLE' || filterItem.name === 'metaValue') {
            if (typeof bucketItem.value === 'string' && bucketItem.value.startsWith('[')) {
              filterItem.value = filterItem.value.slice(1, -1)
            } else if (typeof filterItem.value !== 'string') {
              filterItem.value = filterItem.value && filterItem.value.length && filterItem.value.join(',')
            }
          }
          delete (filterItem.__typename)
          return filterItem
        })
      }
      requestParams.filterRule = otherFilterItems
    }
    return requestParams
  }

  // make sure this function is called when where there is an update in buck list inside version, if not then multiselect reorder will crash
  updateEntitiesAndClearSelection = (bucketItemList, versionId) => {
    const newEntities = this.loadVersionBucketDetailsTolistData(cloneDeep(bucketItemList), versionId)
    this.setState(prevState => {
      return {
        ...prevState,
        entitiesInsideVersions: {
          ...prevState.entitiesInsideVersions,
          [versionId]: newEntities
        },
        selectedTaskIdsInsideVersions: []
      }
    })
  }

  handleAssetDragAndDrop = async (dragAndDropDetails, dragActionInfo, versionRef) => {
    const { selectedTaskIdsInsideVersions, entitiesInsideVersions } = this.state
    this.setState({
      dragAndDropDetails
    })
    // const checkIfAssetAlreadyExits = (bucketItems, draggableId) => {
    //   // console.log('details', { bucketItems, draggableId })
    //   let allowDrop = true
    //   bucketItems.forEach(item => {
    //     // console.log('upper', { dragAndDropDetails, dragActionInfo, flag: draggableId?.includes(item?.asset?.id), item })
    //     if (draggableId?.includes(item?.asset?.id)) {
    //       allowDrop = false
    //     }
    //   })
    //   return allowDrop
    // }
    const { source, destination, draggableId } = dragAndDropDetails
    // just swap positions
    const bucketDetails = cloneDeep(this.state.bucketDetails)
    const bucketId = bucketDetails?.id
    const versionToVersionDrag = dragActionInfo === BUCKET_MANAGER_DARG_ACTION_TYPES.VERSION_TO_VERSION
    const activeToActiveDrag = dragActionInfo === BUCKET_MANAGER_DARG_ACTION_TYPES.ACTIVE_VERSION_TO_ACTIVE_VERSION
    // const versionToActiveDrag = dragActionInfo === BUCKET_MANAGER_DARG_ACTION_TYPES.VERSION_TO_ACTIVE_VERSION
    // const activeToVersionDrag = dragActionInfo === BUCKET_MANAGER_DARG_ACTION_TYPES.ACTIVE_VERSION_TO_VERSION
    // const bucketToVersionDrag = dragActionInfo === BUCKET_MANAGER_DARG_ACTION_TYPES.BUCKET_TO_VERSION
    // const bucketToActiveDrag = dragActionInfo === BUCKET_MANAGER_DARG_ACTION_TYPES.BUCKET_TO_ACTIVE_VERSION
    // const activeToBucketDrag = dragActionInfo === BUCKET_MANAGER_DARG_ACTION_TYPES.ACTIVE_VERSION_TO_BUCKET
    // const versionToBucketDrag = dragActionInfo === BUCKET_MANAGER_DARG_ACTION_TYPES.VERSION_TO_BUCKET
    const sidebarAssetsToActive = dragActionInfo === BUCKET_MANAGER_DARG_ACTION_TYPES.BUCKET_SIDEBAR_ASSETS_TO_ACTIVE_VERSION
    const sidebarAssetsToVersion = dragActionInfo === BUCKET_MANAGER_DARG_ACTION_TYPES.BUCKET_SIDEBAR_ASSETS_TO_VERSION

    if (activeToActiveDrag || versionToVersionDrag) {
      // user dragged asset within a version / swapped assets within version
      if (source.droppableId === destination.droppableId) {
        // const versionBucketItemsOrderTracker = this.state.versionBucketItemsOrderTracker
        // const copyOfUpdatedVersionBucketItems = cloneDeep(this.state.updatedVersionBucketItems)
        const copyOfBucketDetails = {
          ...bucketDetails,
          versions: bucketDetails.versions.map((version, versionIndex) => {
            const versionId = version?.id
            if (destination?.droppableId?.includes(versionId)) {
              const versionCopy = cloneDeep(version)
              let copyOfBucketItemsOfVersion = []
              const selectedItems = selectedTaskIdsInsideVersions?.[versionId] || []
              if (selectedItems?.length > 1) {
                const entities = entitiesInsideVersions?.[versionId] || {}
                let tempEntities = _.cloneDeep(entities)
                const modifiedDestination = cloneDeep(destination)
                const modifiedSource = cloneDeep(source)
                modifiedSource.droppableId = `#Bucket_${versionId}`
                modifiedDestination.droppableId = `#Bucket_${versionId}`
                const args = cloneDeep({
                  entities: tempEntities,
                  selectedTaskIds: selectedItems,
                  source: modifiedSource,
                  destination: modifiedDestination
                })
                const processed = multiDragAwareReorder(args)
                const selectedIds = processed.entities.columns[`#Bucket_${versionId}`].taskIds
                const newArray = []
                selectedIds.forEach((selectedId, index) => {
                  for (var [key, values] of Object.entries(processed.entities.tasks)) {
                    if (key === selectedId) {
                      values.position = index
                      newArray.push(values)
                    }
                  }
                })
                copyOfBucketItemsOfVersion = newArray
                this.updateEntitiesAndClearSelection(newArray, versionId)
              } else {
                copyOfBucketItemsOfVersion = cloneDeep(version.bucketItems)
                const removedItem = copyOfBucketItemsOfVersion.splice(source.index, 1)
                copyOfBucketItemsOfVersion.splice(destination.index, 0, removedItem[0])
                removedItem[0].trackPosChange = true
                this.updateEntitiesAndClearSelection(copyOfBucketItemsOfVersion, versionId)
              }

              const repositionedBucketItems = this.positionAdjuster(copyOfBucketItemsOfVersion)
              // mark asset as changed asset in separate state, so as to ad them in params when saving
              // const oldVersionList = this.state.bucketDetailsForComparison?.versions?.find(versionItem => versionItem.id === version.id)
              // const changedItems = this.getUpdatedAssets(oldVersionList?.bucketItems, repositionedBucketItems, bucketId)
              // copyOfUpdatedVersionBucketItems[versionId] = changedItems
              versionCopy.bucketItems = repositionedBucketItems
              return versionCopy
            }
            return version
          })
        }
        this.setState({
          bucketDetails: copyOfBucketDetails,
          isSaveEnable: true
          // updatedVersionBucketItems: copyOfUpdatedVersionBucketItems,
          // versionBucketItemsOrderTracker
        })
        this.props.changeBucket(bucketId, true)
        console.log('called')
      }

      // else {
      //   // user dragged one asset from one version to another version
      //   let itemToAdd = null
      //   let allowDrop = true
      //   const copyOfUpdatedVersionBucketItems = cloneDeep(this.state.updatedVersionBucketItems)
      //   const versionsWithBucketItemsRemoved = cloneDeep(this.state.bucketDetails.versions).map(version => {
      //     if (source?.droppableId?.includes(version?.id)) {
      //       const versionId = version?.id
      //       const versionCopy = cloneDeep(version)
      //       const copyOfBucketItemsInVersion = version.bucketItems.filter(bucketItem => {
      //         if (draggableId?.includes(bucketItem.id)) {
      //           itemToAdd = bucketItem
      //           // when removing also remove from that tracks updates
      //           const itemsToUpdateForThisVersion = copyOfUpdatedVersionBucketItems?.[versionId] || []
      //           const newItems = itemsToUpdateForThisVersion.filter(item => item.id !== bucketItem.id)
      //           const existing = copyOfUpdatedVersionBucketItems?.[versionId] || []
      //           copyOfUpdatedVersionBucketItems[versionId] = uniqBy([...existing, ...newItems], 'id')
      //           return false
      //         }
      //         return true
      //       })
      //       versionCopy.bucketItems = copyOfBucketItemsInVersion
      //       return versionCopy
      //     }
      //     return version
      //   })
      //   const versionsWithBucketItemsAdded = cloneDeep(versionsWithBucketItemsRemoved).map(version => {
      //     if (destination?.droppableId?.includes(version?.id)) {
      //       const versionId = version?.id
      //       const versionCopy = cloneDeep(version)
      //       const copyOfBucketItemsInVersion = versionCopy?.bucketItems || []
      //       allowDrop = checkIfAssetAlreadyExits(copyOfBucketItemsInVersion, draggableId)
      //       if (!allowDrop) return version
      //       copyOfBucketItemsInVersion.splice(destination.index, 0, itemToAdd)
      //       // versionCopy.bucketItems = copyOfBucketItemsInVersion
      //       // when adding also add to state that tracks updates
      //       itemToAdd.trackPosChange = true
      //       const changedBucketItem = this.getBucketItemStructureForSaveRequest(itemToAdd, bucketId)
      //       const existing = copyOfUpdatedVersionBucketItems?.[versionId] || []
      //       copyOfUpdatedVersionBucketItems[versionId] = uniqBy([...existing, changedBucketItem], 'id')
      //       return versionCopy
      //     }
      //     return version
      //   })
      //   if (allowDrop) {
      //     const copyOfBucketDetails = {
      //       ...bucketDetails,
      //       versions: versionsWithBucketItemsAdded
      //     }
      //     this.setState({
      //       updatedVersionBucketItems: copyOfUpdatedVersionBucketItems,
      //       bucketDetails: copyOfBucketDetails,
      //       isSaveEnable: true
      //     })
      //     this.props.changeBucket(bucketId, true)
      //   } else {
      //     message.warning(userMessages.ASSET_ALREADY_ADDED_MSG)
      //   }
      // }
    } else if (sidebarAssetsToActive || sidebarAssetsToVersion) {
      const assetId = draggableId.split('#')?.[0]
      const asset = this.props.assetList?.find(asset => asset.id === assetId)
      const buckets = {
        type: 'ASSET',
        assetId,
        bucket: this.props.bucketId,
        position: destination.index
      }
      const tempId = getUuid(draggableId + destination.droppableId)
      const tempAsset = {
        id: tempId,
        asset,
        type: 'ASSET',
        position: destination.index,
        isLoading: true
      }
      let bucketListDetails = cloneDeep(this.state.bucketDetails)
      const bucketVersion = bucketListDetails.versions.find(versionItem => {
        if (destination.droppableId?.includes(versionItem.id)) {
          return true
        }
        return false
      })
      let bucketItems = bucketVersion?.bucketItems || []
      const isAssetPresent = bucketItems.find((item) => item?.asset?.id === assetId)
      if (_.isEmpty(isAssetPresent)) {
        this.props.setBucketGroupDetailsState({ bucketVersionAPILoading: true })
        bucketItems.splice(destination.index, 0, tempAsset)
        bucketVersion.bucketItems = bucketItems
        this.setState({
          bucketDetails: bucketListDetails,
          entities: this.loadBucketDetailsTolistData(bucketListDetails)
        })
        try {
          buckets.version = bucketVersion.id
          const response = await this.props.createBucketItem({ bucketItems: [buckets] })
          this.props.updateHistory()
          const index = bucketItems.findIndex((item) => item.id === tempAsset.id)
          bucketItems[index] = response.data.batchCreateBucketItem[0]
          bucketItems = bucketItems.map((item, index) => {
            item.position = index >= destination.index ? index : item.position
            delete (item.__typename)
            return item
          })
          this.updateEntitiesAndClearSelection(bucketItems, bucketVersion.id)
          bucketVersion.bucketItems = bucketItems
          this.setState({
            bucketDetails: bucketListDetails,
            entities: this.loadBucketDetailsTolistData(bucketListDetails)
          }, () => {
            this.props.changeBucket(bucketListDetails.id, true)
            this.setState({ isSaveEnable: true })
          })
          this.props.clearDragDropId()
          this.props.setBucketGroupDetailsState({ bucketVersionAPILoading: false })
        } catch (err) {
          this.props.setBucketGroupDetailsState({ bucketVersionAPILoading: false })
          this.getBucket(err)
        }
      } else {
        message.warning(userMessages.ASSET_ADDED_ALREADY)
      }
    }

    // else if (activeToVersionDrag || versionToActiveDrag) {
    //   // user dragged asset from a an active version to another version or  vice versa
    //   let itemToAdd = null
    //   let allowDrop = true
    //   const copyOfUpdatedVersionBucketItems = cloneDeep(this.state.updatedVersionBucketItems)
    //   const versionsWithBucketItemsRemoved = cloneDeep(this.state.bucketDetails.versions).map(version => {
    //     if (source?.droppableId?.includes(version?.id)) {
    //       const versionId = version.id
    //       const versionCopy = cloneDeep(version)
    //       const copyOfBucketItemsInVersion = version.bucketItems.filter(bucketItem => {
    //         if (draggableId?.includes(bucketItem.id)) {
    //           itemToAdd = bucketItem
    //           // when removing also remove from that tracks updates
    //           const existing = copyOfUpdatedVersionBucketItems?.[versionId] || []
    //           const newItems = existing.filter(item => item.id !== bucketItem.id)
    //           copyOfUpdatedVersionBucketItems[versionId] = newItems
    //           return false
    //         }
    //         return true
    //       })
    //       versionCopy.bucketItems = copyOfBucketItemsInVersion
    //       return versionCopy
    //     }
    //     return version
    //   })
    //   const versionsWithBucketItemsAdded = cloneDeep(versionsWithBucketItemsRemoved).map(version => {
    //     if (destination?.droppableId?.includes(version?.id) && !isEmpty(itemToAdd)) {
    //       const versionId = version?.id
    //       const versionCopy = cloneDeep(version)
    //       const copyOfBucketItemsOfVersion = versionCopy?.bucketItems || []
    //       allowDrop = checkIfAssetAlreadyExits(copyOfBucketItemsOfVersion, draggableId)
    //       if (!allowDrop) return version
    //       copyOfBucketItemsOfVersion.splice(destination.index, 0, itemToAdd)
    //       // versionCopy.bucketItems = copyOfBucketItemsOfVersion
    //       // when adding also add to state that tracks updates
    //       itemToAdd.trackPosChange = true
    //       const changedBucketItem = this.getBucketItemStructureForSaveRequest(itemToAdd, bucketId)
    //       const existing = copyOfUpdatedVersionBucketItems?.[versionId] || []
    //       copyOfUpdatedVersionBucketItems[versionId] = [...existing, changedBucketItem]
    //       return versionCopy
    //     }
    //     return version
    //   })
    //   if (allowDrop) {
    //     const copyOfBucketDetails = {
    //       ...bucketDetails,
    //       versions: versionsWithBucketItemsAdded
    //     }
    //     this.setState({
    //       updatedVersionBucketItems: copyOfUpdatedVersionBucketItems,
    //       bucketDetails: copyOfBucketDetails,
    //       isSaveEnable: true
    //     })
    //     this.props.changeBucket(bucketId, true)
    //   } else {
    //     message.warning(userMessages.ASSET_ALREADY_ADDED_MSG)
    //   }
    // } else if (bucketToVersionDrag || bucketToActiveDrag) {
    //   // user dragged asset from default bucket to version or version to default bucket
    //   let itemToAdd = null
    //   let allowDrop = true
    //   const copyOfUpdatedVersionBucketItems = cloneDeep(this.state.updatedVersionBucketItems)
    //   const bucketItemsWithItemRemoved = bucketDetails.bucketItems.filter(bucketItem => {
    //     if (draggableId?.includes(bucketItem.id)) {
    //       itemToAdd = bucketItem
    //       return false
    //     }
    //     return true
    //   })
    //   const versionsWithBucketItemsAdded = cloneDeep(this.state.bucketDetails.versions).map(version => {
    //     if (destination?.droppableId?.includes(version?.id) && !isEmpty(itemToAdd)) {
    //       const versionId = version.id
    //       const versionCopy = cloneDeep(version)
    //       let copyOfBucketItemsOfVersion = versionCopy?.bucketItems || []
    //       allowDrop = checkIfAssetAlreadyExits(copyOfBucketItemsOfVersion, draggableId)
    //       if (!allowDrop) return version
    //       copyOfBucketItemsOfVersion.splice(destination.index, 0, itemToAdd)
    //       console.log('details', {
    //         before: version,
    //         after: versionCopy,
    //         beforeBucketItems: version.bucketItems,
    //         afterBucketItems: versionCopy.bucketItems,
    //         dragAndDropDetails,
    //         copyOfBucketItemsOfVersion
    //       })
    //       // versionCopy.bucketItems = copyOfBucketItemsOfVersion
    //       // when adding also add to state that tracks updates
    //       itemToAdd.trackPosChange = true
    //       copyOfBucketItemsOfVersion = this.positionAdjuster(copyOfBucketItemsOfVersion)
    //       versionCopy.bucketItems = copyOfBucketItemsOfVersion
    //       const changedBucketItem = this.getBucketItemStructureForSaveRequest(itemToAdd, bucketId)
    //       const existing = copyOfUpdatedVersionBucketItems?.[versionId] || []
    //       copyOfUpdatedVersionBucketItems[versionId] = uniqBy([...existing, changedBucketItem], 'id')
    //       return versionCopy
    //     }
    //     return version
    //   })
    //   if (allowDrop) {
    //     const copyOfBucketDetails = {
    //       ...bucketDetails,
    //       versions: versionsWithBucketItemsAdded,
    //       bucketItems: bucketItemsWithItemRemoved
    //     }
    //     this.setState({
    //       updatedVersionBucketItems: copyOfUpdatedVersionBucketItems,
    //       bucketDetails: copyOfBucketDetails,
    //       isSaveEnable: true
    //     })
    //     this.props.changeBucket(bucketId, true)
    //   } else {
    //     message.warning(userMessages.ASSET_ALREADY_ADDED_MSG)
    //   }
    // } else if (activeToBucketDrag || versionToBucketDrag) {
    //   // user dragged asset from a an active version to default bucket or from version to default bucket
    //   let itemToAdd = null
    //   let allowDrop = true
    //   const copyOfUpdatedVersionBucketItems = cloneDeep(this.state.updatedVersionBucketItems)
    //   const versionsWithBucketItemsRemoved = cloneDeep(this.state.bucketDetails.versions).map(version => {
    //     if (source?.droppableId?.includes(version?.id)) {
    //       const versionId = version.id
    //       const versionCopy = cloneDeep(version)
    //       const bucketVersions = version?.bucketItems || []
    //       const copyOfBucketItemsOfVersion = bucketVersions.filter(bucketItem => {
    //         if (draggableId?.includes(bucketItem.id)) {
    //           itemToAdd = bucketItem
    //           // when removing also remove from that tracks updates
    //           const itemsToUpdateForThisVersion = copyOfUpdatedVersionBucketItems?.[versionId] || []
    //           const newItems = itemsToUpdateForThisVersion.filter(item => item.id !== bucketItem.id)
    //           copyOfUpdatedVersionBucketItems[versionId] = newItems
    //           return false
    //         }
    //         return true
    //       })
    //       versionCopy.bucketItems = copyOfBucketItemsOfVersion
    //       return versionCopy
    //     }
    //     return version
    //   })
    //   const copyOfBucketItems = cloneDeep(bucketDetails.bucketItems)
    //   allowDrop = checkIfAssetAlreadyExits(copyOfBucketItems, draggableId)
    //   if (allowDrop) {
    //     copyOfBucketItems.splice(destination.index, 0, itemToAdd)
    //     const copyOfBucketDetails = {
    //       ...bucketDetails,
    //       versions: versionsWithBucketItemsRemoved,
    //       bucketItems: copyOfBucketItems
    //     }
    //     this.setState({
    //       updatedVersionBucketItems: copyOfUpdatedVersionBucketItems,
    //       bucketDetails: copyOfBucketDetails,
    //       isSaveEnable: true
    //     })
    //     this.props.changeBucket(bucketId, true)
    //   } else {
    //     message.warning(userMessages.ASSET_ALREADY_ADDED_MSG)
    //   }
    // }
  }

  handleBucketVersionCreation = async ({ versionName, setVersionName }) => {
    const { bucketId, handleBucketVersionModal } = this.props
    const params = {
      name: versionName,
      bucketId
    }
    try {
      this.setState({ isCreateBucketVersionLoading: true })
      await this.props.createBucketVersion(params)
      this.props.updateHistory()
      await this.props.fetchMoreBucketDetails()
      message.success(userMessages.CREATE_BUCKET_VERSION_SUCCESS)
      this.setState({ isCreateBucketVersionLoading: false })
      handleBucketVersionModal(false, BUCKET_VERSION_MODAL_TYPES.CREATE_BUCKET_VERSION_MODAL)
      setVersionName('')
    } catch (err) {
      this.setState({ isCreateBucketVersionLoading: false })
      utilityService.handleError(err)
    }
  }

  handleBucketVersionUpdation = async ({ basicStartDate, basicEndDate }) => {
    const { bucketDetails } = this.state
    const { updateBucketVersionModalId, bucketId, handleBucketVersionModal } = this.props
    const versionItem = bucketDetails?.versions.find(versionItem => versionItem.id === updateBucketVersionModalId)
    const versions = bucketDetails?.versions
    if (!basicStartDate) {
      message.error('Start date is required')
      return
    }
    if (!basicEndDate) {
      message.error('End date is required')
      return
    }
    const newStartDate = moment(basicStartDate).utc()
    const newEndDate = moment(basicEndDate).utc()
    const checkForExistingSchedule = (versions = []) => {
      let rangeFallsInBetween = null
      versions.forEach(versionItemDetails => {
        // if user trying to edit same version that has already start date and end date no need to compare it with other versions so return else proceed
        if (versionItemDetails.id === updateBucketVersionModalId) return
        const existingStartDate = moment(versionItemDetails.publishStartDate).utc()
        const existingEndDate = moment(versionItemDetails.publishEndDate).utc()
        const isNewStartDateBetween = newStartDate.isBetween(existingStartDate, existingEndDate, null, '[]')
        const isNewEndDateInBetween = newEndDate.isBetween(existingStartDate, existingEndDate, null, '[]')
        const isExistingStartDateInBetween = existingStartDate.isBetween(newStartDate, newEndDate, null, '[]')
        const isExistingEndDateInBetween = existingEndDate.isBetween(newEndDate, newEndDate, null, '[]')
        const startDatesEqual = newStartDate.format('DD-MM-YYYY hh:mm:ss') === existingStartDate.format('DD-MM-YYYY hh:mm:ss')
        const endDatesEqual = newEndDate.format('DD-MM-YYYY hh:mm:ss') === existingEndDate.format('DD-MM-YYYY hh:mm:ss')
        // console.log(`
        //   ${versionItemDetails.name}
        //   existing start :: ${existingStartDate.format('DD-MM-YYYY hh:mm:ss')}
        //   existing end :: ${existingEndDate.format('DD-MM-YYYY hh:mm:ss')}

        //   new start ::  ${newStartDate.format('DD-MM-YYYY hh:mm:ss')}
        //   new end ::  ${newEndDate.format('DD-MM-YYYY hh:mm:ss')}
        // `, { isStartDateInBetween: isNewStartDateBetween, isEndDateInBetween: isNewEndDateInBetween, startDatesEqual, endDatesEqual, isExistingStartDateInBetween })
        if (isNewStartDateBetween || isNewEndDateInBetween || startDatesEqual || endDatesEqual || isExistingStartDateInBetween || isExistingEndDateInBetween) {
          rangeFallsInBetween = versionItemDetails
        }
      })
      return rangeFallsInBetween
    }
    const hasExistingSchedule = checkForExistingSchedule(versions)
    if (hasExistingSchedule) {
      message.error(`The date range has already been selected for Version - ${hasExistingSchedule.name}`)
      return
    }
    const bucketItemsIdArray = versionItem.bucketItems.map(item => item.id)
    const params = {
      input: {
        id: updateBucketVersionModalId,
        name: versionItem.name,
        bucketItems: bucketItemsIdArray,
        isPublished: versionItem.isPublished,
        publishStartDate: moment(basicStartDate).utc(),
        publishEndDate: moment(basicEndDate).utc()
      },
      bucketId
    }
    await this.updateBucketVersion(params)
    message.success(userMessages.UPDATE_BUCKET_VERSION_SUCCESS)
    handleBucketVersionModal(null, BUCKET_VERSION_MODAL_TYPES.UPDATE_BUCKET_VERSION_MODAL)
  }

  handleBucketVersionEnableDisable = async (flag, versionId) => {
    const { bucketDetails } = this.state
    const { bucketId, handleBucketVersionModal } = this.props
    const versionItem = bucketDetails?.versions.find(versionItem => versionItem.id === versionId)
    if (!versionItem.publishStartDate || !versionItem.publishEndDate) {
      message.warning('Start date and End date is required for publishing this version')
      return
    }
    const bucketItemsIdArray = versionItem.bucketItems.map(item => item.id)
    const params = {
      input: {
        id: versionId,
        name: versionItem.name,
        bucketItems: bucketItemsIdArray,
        isPublished: flag,
        publishStartDate: versionItem.publishStartDate,
        publishEndDate: versionItem.publishEndDate
      },
      bucketId
    }
    await this.updateBucketVersion(params)
    message.success(userMessages.UPDATE_BUCKET_VERSION_SUCCESS)
    handleBucketVersionModal(null, BUCKET_VERSION_MODAL_TYPES.UPDATE_BUCKET_VERSION_MODAL)
  }

  updateBucketVersion = async (params) => {
    try {
      this.setState({ isUpdateBucketVersionModalLoading: true })
      const updateDetails = await this.props.updateBucketVersion(params)
      this.props.updateHistory()
      await this.props.fetchMoreBucketDetails()
      this.setState({ isUpdateBucketVersionModalLoading: false })
      return updateDetails
    } catch (err) {
      this.setState({ isUpdateBucketVersionModalLoading: false })
      utilityService.handleError(err)
    }
  }

  confirmBucketVersionDeletion = async () => {
    const { bucketDetails, deleteBucketVersionId } = this.state
    try {
      this.setState({ isBucketVersionDeleting: true })
      await this.props.deleteBucketVersion({
        id: deleteBucketVersionId,
        bucketId: bucketDetails.id
      })
      this.props.updateHistory()
      await this.props.fetchMoreBucketDetails()
      this.setState({ isBucketVersionDeleting: false, deleteBucketVersionId: null })
      message.success(userMessages.DELETE_BUCKET_VERSION_SUCCESS)
    } catch (err) {
      this.setState({ isBucketVersionDeleting: false })
      utilityService.handleError(err)
    }
  }

  handleCopySchedule = async (idOfVersionOrDefaultBucketToCopyFrom, idOfVersionOrDefaultBucketToCopyTo, setCopyFromVersion) => {
    const generateBucketItemsWithNewIds = (bucketItems) => {
      const bucketItemsWithNewIds = bucketItems.map(bucketItem => {
        return {
          ...bucketItem,
          id: getUuid(bucketItem.id + copyToIndex)
        }
      })
      return bucketItemsWithNewIds
    }
    const { bucketDetails } = this.state
    // const { bucketId } = this.props
    let versionItemToCopyFrom = []
    // let versionItemToCopyTo = null
    const copyingToDefaultBucket = idOfVersionOrDefaultBucketToCopyTo === COPY_OPTIONS_ID_TYPES.DEFAULT
    const copyOfBucketDetails = cloneDeep(bucketDetails)
    const copyToIndex = copyOfBucketDetails.versions.findIndex(versionItem => versionItem.id === idOfVersionOrDefaultBucketToCopyTo)
    const copyToVersion = copyOfBucketDetails.versions[copyToIndex]
    const copyFromIndex = copyOfBucketDetails.versions.findIndex(versionItem => (versionItem.id === idOfVersionOrDefaultBucketToCopyFrom) && isEmpty(versionItemToCopyFrom))
    versionItemToCopyFrom = copyOfBucketDetails.versions[copyFromIndex]
    if (copyingToDefaultBucket) {
      // clearing states if user had already did some drag and drops before copying
      (bucketDetails?.bucketItems || []).forEach(bucketItem => {
        this.removeBucketItem(bucketItem.id)
      })
      const bucketItemsWithNewIds = generateBucketItemsWithNewIds(versionItemToCopyFrom?.bucketItems || [])
      this.updateEntitiesAndClearSelection(bucketItemsWithNewIds, copyOfBucketDetails.id)
      copyOfBucketDetails.bucketItems = bucketItemsWithNewIds
    } else {
      // when copying from default bucket, bucket items are not inside versions key in state, its outside so need to handle separately
      if (idOfVersionOrDefaultBucketToCopyFrom === COPY_OPTIONS_ID_TYPES.DEFAULT) {
        versionItemToCopyFrom = bucketDetails
      }
      const bucketItemsWithNewIds = generateBucketItemsWithNewIds(versionItemToCopyFrom?.bucketItems || [])
      this.updateEntitiesAndClearSelection(bucketItemsWithNewIds, copyToVersion.id)
      copyToVersion.bucketItems = bucketItemsWithNewIds
    }
    this.setState({
      bucketDetails: copyOfBucketDetails,
      versionIdToCopyTo: null,
      isSaveEnable: true
    })
    this.props.changeBucket(this.state.bucketDetails.id, true)
    setCopyFromVersion(null)

    // console.log('tooo', { copyFromVersion, copyToVersion, copyOfBucketDetails })

    // const newVersions = copyOfBucketDetails.versions.find(versionItem => {
    //   let versionItemToCopyFrom = null
    //   if ((versionItem.id === versionIdToCopyFrom) && isEmpty(versionItemToCopyFrom)) {
    //     versionItemToCopyFrom = versionItem
    //   }
    //   if (versionItem.id === versionIdToCopyTo) {
    //     // versionItemToCopyTo = cloneDeep(versionItem)
    //   }
    // })
    // copyOfBucketDetails.versions = newVersions

    // const existingBucketIdArray = versionItemToCopyTo?.bucketItems?.map(item => item.id) || []
    // const bucketItemsIdArray = versionItemToCopyFrom?.bucketItems?.map(item => item.id) || []
    // const bucketItemsArray = existingBucketIdArray
    // bucketItemsIdArray.forEach(id => {
    //   if (!bucketItemsArray.includes(id)) {
    //     bucketItemsArray.push(id)
    //   }
    // })
    // const params = {
    //   input: {
    //     id: versionIdToCopyTo,
    //     name: versionItemToCopyTo.name,
    //     publishStartDate: versionItemToCopyTo.publishStartDate,
    //     publishEndDate: versionItemToCopyTo.publishEndDate,
    //     isPublished: versionItemToCopyTo.isPublished,
    //     // only bucket items will change
    //     bucketItems: bucketItemsArray
    //   },
    //   bucketId
    // }
    // await this.updateBucketVersion(params)
    // message.success(userMessages.COPY_BUCKET_VERSION_SUCCESS)
    // this.setState({
    //   versionIdToCopyTo: null
    // })
    // setCopyFromVersion(null)
  }
  getActiveDroppableId = (versionId, bucketId) => {
    return `${ACTIVE_VERSION_DROPPABLE_ID}${versionId}_${bucketId}`
  }

  getActiveOrVersionDraggableId = (draggableId, versionId) => {
    return `${draggableId}_versionId=${versionId}_`
  }

  getCopyOptions = () => {
    const { bucketDetails, versionIdToCopyTo } = this.state
    if (isEmpty(bucketDetails)) return []
    const defaultItem = {
      name: `${bucketDetails.name} - DEFAULT`,
      id: COPY_OPTIONS_ID_TYPES.DEFAULT
    }
    const options = bucketDetails?.versions?.filter(item => item.id !== versionIdToCopyTo)?.map(item => {
      return {
        id: item.id,
        name: item.name
      }
    }) || []
    // dont show default option if user is opening modal by clicking copy icon on default bucket
    if (versionIdToCopyTo !== COPY_OPTIONS_ID_TYPES.DEFAULT) {
      options.push(defaultItem)
    }
    return options
  }

  handleBucketDetailCellState = (stateObject) => {
    // if (stateObject.hasOwnProperty('abcd')) {
    //   console.log('stateObject', stateObject)
    //   this.setState({
    //     entitiesInsideVersions: stateObject.entitiesInsideVersions
    //   })
    // } else {
    // }
    this.setState(stateObject)
  }
  getBucketDetailCellState= () => this.state

  render () {
    const { isEditted, bucketDetails, visible, isSaveEnable, loading, showWarning, showPublish, saveLoading, addFilterLoading, isScroll, isWarningShow,
      isModifiedLoading, tempBucketDetails, selectedTaskIds,
      showBucketVersions,
      basicDateRangeDetails,
      selectedTaskIdsInsideVersions
    } = this.state
    const { bucketId, deleteBucketGroupItem, selected, updateHistory, displayTypes, isCreateBlocked, isUpdateBlocked,
      isDeleteBlocked, draggingTaskId, isUpdateDisabledContent, isCreateDisabledContent, isDeleteDisabledContent, project,
      droppableId,
      clearDragDropId,
      changeLoadingBucket,
      bucketGroupId,
      bucketVersionHeader,
      handleBucketVersionMode,
      isVersionOnlyMode,
      isCreateBucketVersionModalOpen,
      handleBucketVersionModal,
      updateBucketVersionModalId,
      bucketVersionAPILoading
    } = this.props
    // check if any item is active inside versions by checking current time
    const bucketVersions = bucketDetails?.versions || []
    const {
      currentActiveBucketVersion,
      reorderedVersions,
      scheduledVersions
    } = this.getVersionDetails(bucketVersions)
    const numberOfBucketVersions = scheduledVersions?.length

    const defaultBucketItems = (
      <div className={`bucket-detail-cell${selected ? ' selected' : ''} ${numberOfBucketVersions ? 'bucket-detail-cell-has-scheduled-versions' : 'bucket-detail-cell-zero-scheduled-versions'}`} id={`bucket-detail-cell-${bucketId}`}>
        {saveLoading ? <div className='overlay' /> : ''}
        {/* <p>id::: {bucketId}</p> */}
        <BucketDetailHeading onAddSearch={this.onAddSearch}
          bucketName={bucketDetails ? bucketDetails.name : undefined}
          bucketType={bucketDetails && bucketDetails.displayType ? bucketDetails.displayType.name : undefined}
          status={bucketDetails?.status}
          bucketId={bucketDetails ? bucketDetails.key : undefined}
          activeVersionName={null}
          numberOfBucketVersions={numberOfBucketVersions}
          id={bucketId}
          onBucketEditClick={this.onBucketEditClick}
          deleteBucket={() => this.toggleDeleteeWarningMessage(true)}
          saveBucket={this.saveBucket}
          showPublish={this.showPublish}
          copyLink={this.copyLink}
          editBucket={this.onBucketEditClick}true
          isSaveEnable={isSaveEnable}
          isDisableAddFilter={this.getAddFilterStatus() || saveLoading || addFilterLoading}
          loading={saveLoading}
          // isCreateBlocked={isCreateBlocked}
          isUpdateBlocked={isUpdateBlocked}
          isDeleteBlocked={isDeleteBlocked}
          isSelectionBlocking={!bucketDetails}
          project={project}
          handleShowHideBucketVersion={() => {
            const { bucketId } = this.props
            const { showBucketVersions } = this.state
            const showBucketDetails = cloneDeep(showBucketVersions)
            const isOpen = showBucketDetails?.[bucketId]
            if (isOpen) {
              delete showBucketDetails[bucketId]
              this.setState({ showBucketVersions: showBucketDetails })
              handleBucketVersionMode(false, bucketId)
            } else {
              this.setState({
                showBucketVersions: {
                  ...this.state.showBucketVersions,
                  [bucketId]: true
                }
              })
              handleBucketVersionMode(true, bucketId)
            }
          }}
          isVersionOnlyMode={isVersionOnlyMode}
          handleCopySchedule={() => {
            this.setState({
              versionIdToCopyTo: COPY_OPTIONS_ID_TYPES.DEFAULT
            })
          }}
        />
        { bucketDetails ? <BucketDetailList
          listData={cloneDeep(bucketDetails.bucketItems) || []}
          // listData={this.getSortedList(cloneDeep(bucketDetails.bucketItems)) || []}
          isEditted={isEditted}
          onAddImage={this.onAddImage}
          onChangeFilter={this.onChangeFilter}
          onDragEnd={this.onDragEnd}
          handleAssetTitle={this.onAssetTitleChange}
          handleAssetTitleReset={this.onAssetTitleReset}
          handleAssetDisplayImageReset={this.onAssetDisplayImageReset}
          onAssetDisplayImageChange={this.onAssetDisplayImageChange}
          bucketId={bucketId}
          removeBucketItem={this.removeBucketItem}
          parent={parent}
          isSaveEnable={isSaveEnable}
          saveLoading={saveLoading}
          parentCompoent={`bucket-detail-cell-${bucketId}`}
          isScroll={isScroll}
          onBucketScroll={this.onBucketScroll}
          isUpdateBlocked={isUpdateBlocked}
          isCreateBlocked={isCreateBlocked}
          selectedTaskIds={selectedTaskIds}
          toggleSelection={this.toggleSelection}
          toggleSelectionInGroup={this.toggleSelectionInGroup}
          multiSelectTo={this.multiSelectTo}
          draggingTaskId={draggingTaskId}
          project={project}
          isUpdateDisabledContent={isUpdateDisabledContent}
          isCreateDisabledContent={isCreateDisabledContent}
          isDeleteDisabledContent={isDeleteDisabledContent}
          droppableIdData={`#Bucket_${bucketId}`}
        /> : <React.Fragment>
          <Skeleton active avatar={{ size: 'large', shape: 'default' }} title={false} paragraph={{ rows: 3, width: ['calc(100% - 100px)', '50%', '100%'] }} loading />
          <Skeleton active avatar={{ size: 'large', shape: 'default' }} title={false} paragraph={{ rows: 3, width: ['calc(100% - 100px)', '50%', '100%'] }} loading />
        </React.Fragment> }

        <UpdateBucketVersionModal
          visible={updateBucketVersionModalId === bucketId}
          onOk={this.handleBucketVersionUpdation}
          onCancel={() => {
            handleBucketVersionModal(null, BUCKET_VERSION_MODAL_TYPES.UPDATE_BUCKET_VERSION_MODAL)
          }}
          loading={this.state.isUpdateBucketVersionModalLoading}
          basicDateRangeDetails={basicDateRangeDetails}
        />

      </div>
    )

    const activeBucketVersion = currentActiveBucketVersion && (
      <div className={`bucket-detail-cell${selected ? ' selected' : ''} bucket-detail-cell-active-non-version-mode ${numberOfBucketVersions ? 'bucket-detail-cell-has-scheduled-versions' : 'bucket-detail-cell-zero-scheduled-versions'}`} id={`bucket-detail-cell-${bucketId}`}>
        <BucketDetailHeading
          onAddSearch={() => this.onAddSearch(currentActiveBucketVersion?.id)}
          bucketName={currentActiveBucketVersion?.name}
          activeVersionName={currentActiveBucketVersion?.name}
          numberOfBucketVersions={numberOfBucketVersions}
          bucketType={
            bucketDetails && bucketDetails.displayType
              ? bucketDetails.displayType.name
              : undefined
          }
          status={bucketDetails?.status}
          bucketId={bucketDetails ? bucketDetails.key : undefined}
          id={bucketId}
          onBucketEditClick={this.onBucketEditClick}
          deleteBucket={() => this.toggleDeleteeWarningMessage(true)}
          saveBucket={this.saveBucket}
          showPublish={() => handleBucketVersionModal(currentActiveBucketVersion?.id, BUCKET_VERSION_MODAL_TYPES.UPDATE_BUCKET_VERSION_MODAL)}
          copyLink={this.copyLink}
          editBucket={this.onBucketEditClick}
          isSaveEnable={isSaveEnable}
          isDisableAddFilter={
            this.getAddFilterStatus() ||
              saveLoading ||
              addFilterLoading
          }
          loading={saveLoading}
          // isCreateBlocked={isCreateBlocked}
          isUpdateBlocked={isUpdateBlocked}
          isDeleteBlocked={isDeleteBlocked}
          isSelectionBlocking={!bucketDetails}
          project={project}
          bucketVersionHeader={bucketVersionHeader}
          handleShowHideBucketVersion={() => {
            const { bucketId } = this.props
            const { showBucketVersions } = this.state
            const showBucketDetails = cloneDeep(showBucketVersions)
            const isOpen = showBucketDetails?.[bucketId]
            if (isOpen) {
              delete showBucketDetails[bucketId]
              this.setState({ showBucketVersions: showBucketDetails })
              handleBucketVersionMode(false, bucketId)
            } else {
              this.setState({
                showBucketVersions: {
                  ...this.state.showBucketVersions,
                  [bucketId]: true
                }
              })
              handleBucketVersionMode(true, bucketId)
            }
          }}
          isVersionOnlyMode={isVersionOnlyMode}
        />
        <BucketDetailList
          // listData={this.getSortedList(cloneDeep(currentActiveBucketVersion?.bucketItems)) || []}
          listData={currentActiveBucketVersion?.bucketItems || []}
          isEditted={isEditted}
          onAddImage={this.onAddImage}
          onChangeFilter={(id, value, bucketVersionItem) => this.onChangeFilter(id, value, ACTION_TYPES.ACTION_ON_BUCKET_VERSION, bucketVersionItem)}
          onDragEnd={this.onDragEnd}
          handleAssetTitle={(title, id) => this.onAssetTitleChange(title, id, ACTION_TYPES.ACTION_ON_BUCKET_VERSION, currentActiveBucketVersion)}
          handleAssetTitleReset={(id) => this.onAssetTitleReset(id, ACTION_TYPES.ACTION_ON_BUCKET_VERSION, currentActiveBucketVersion)}
          handleAssetDisplayImageReset={(id) => this.onAssetDisplayImageReset(id, ACTION_TYPES.ACTION_ON_BUCKET_VERSION, currentActiveBucketVersion)}
          onAssetDisplayImageChange={(media, id, defaultMedia) => this.onAssetDisplayImageChange(media, id, defaultMedia, ACTION_TYPES.ACTION_ON_BUCKET_VERSION, currentActiveBucketVersion)}
          bucketId={bucketId}
          removeBucketItem={(itemId) => this.removeBucketItem(itemId, ACTION_TYPES.ACTION_ON_BUCKET_VERSION, currentActiveBucketVersion)}
          parent={parent}
          isSaveEnable={isSaveEnable}
          saveLoading={saveLoading}
          parentCompoent={`bucket-detail-cell-${currentActiveBucketVersion?.id}`}
          isScroll={isScroll}
          onBucketScroll={this.onBucketScroll}
          isUpdateBlocked={isUpdateBlocked}
          isCreateBlocked={isCreateBlocked}
          selectedTaskIds={selectedTaskIdsInsideVersions?.[currentActiveBucketVersion?.id] || []}
          toggleSelection={(taskId) => this.toggleSelectionOnVersions(taskId, currentActiveBucketVersion?.id)}
          toggleSelectionInGroup={(taskId) => this.toggleSelectionInGroupOnVersions(taskId, currentActiveBucketVersion?.id)}
          multiSelectTo={(newTaskId) => this.multiSelectToOnVersions(newTaskId, currentActiveBucketVersion?.id)}
          draggingTaskId={draggingTaskId}
          project={project}
          isUpdateDisabledContent={isUpdateDisabledContent}
          isCreateDisabledContent={isCreateDisabledContent}
          isDeleteDisabledContent={isDeleteDisabledContent}
          bucketDetails={bucketDetails}
          bucketVersionList={bucketVersions}
          showBucketVersionList={showBucketVersions?.[bucketId]}
          droppableIdData={this.getActiveDroppableId(currentActiveBucketVersion.id, bucketId)}
          clearDragDropId={clearDragDropId}
          displayTypes={displayTypes}
          updateHistory={updateHistory}
          isDeleteBlocked={isDeleteBlocked}
          changeLoadingBucket={changeLoadingBucket}
          bucketGroupId={bucketGroupId}
          draggableIdIdentifier={this.getActiveOrVersionDraggableId(VERSION_DRAGGABLE_ID, currentActiveBucketVersion.id)}
          isActive
          bucketVersionAPILoading={bucketVersionAPILoading}
          handleBucketDetailCellState={this.handleBucketDetailCellState}
          getBucketDetailCellState={this.getBucketDetailCellState}
          entitiesInsideVersions={this.state.entitiesInsideVersions?.[currentActiveBucketVersion?.id] || {}}
          selectedTaskIdsInsideVersions={this.state.selectedTaskIdsInsideVersions?.[currentActiveBucketVersion?.id] || []}
          loadVersionBucketDetailsTolistData={this.loadVersionBucketDetailsTolistData}
        />
        <UpdateBucketVersionModal
          visible={updateBucketVersionModalId === currentActiveBucketVersion?.id}
          onOk={this.handleBucketVersionUpdation}
          onCancel={() => {
            handleBucketVersionModal(null, BUCKET_VERSION_MODAL_TYPES.UPDATE_BUCKET_VERSION_MODAL)
          }}
          loading={this.state.isUpdateBucketVersionModalLoading}
          basicDateRangeDetails={basicDateRangeDetails}
        />
      </div>
    )

    return (
      <div className='bucket-detail-cell-wrapper'>
        { !isVersionOnlyMode && (activeBucketVersion || defaultBucketItems) }
        <AddBucketModal visible={visible}
          handleCancel={this.handleCancel}
          createBucket={this.editBucket}
          bucketDetails={bucketDetails}
          isEdit
          loading={loading}
          displayTypes={displayTypes}
        />

        <ConfirmModal
          isVisible={showWarning}
          title={deleteWarningMessage.title}
          message={deleteWarningMessage.message}
          isLoading={false}
          rightButtonText={'Confirm'}
          handleCancel={() => this.toggleDeleteeWarningMessage(false)}
          handleSubmit={() => { deleteBucketGroupItem(); this.toggleDeleteeWarningMessage(false) }}
        />

        <PublishBucketModal visible={showPublish && bucketDetails}
          handleCancel={this.handleCancel}
          bucketId={bucketId}
          updateHistory={updateHistory}
          project={project}
        />

        <ConfirmModal
          isVisible={isWarningShow}
          title={'Warning'}
          message={tempBucketDetails ? `${tempBucketDetails.name} has been modified by ${tempBucketDetails.updatedBy}. Please refetch bucket details to get the latest updates` : ''}
          isLoading={isModifiedLoading}
          rightButtonText={'Refetch data'}
          handleSubmit={this.refetchBucketData}
          isSubmitButtonDisabled={false}
          isCancelButtonDisabled
          isCancelButtonInvisible />

        <CreateBucketVersionModal
          visible={isCreateBucketVersionModalOpen}
          onOk={(args) => {
            const versionNameExists = bucketDetails.versions?.some(item => item.name === args.versionName)
            if (versionNameExists) {
              message.warning(userMessages.VERSION_NAME_ALREADY_EXISTS)
              return
            }
            this.handleBucketVersionCreation(args)
          }}
          onCancel={() => {
            handleBucketVersionModal(false, BUCKET_VERSION_MODAL_TYPES.CREATE_BUCKET_VERSION_MODAL)
          }}
          loading={this.state.isCreateBucketVersionLoading}
        />

        <CopyVersionModal
          visible={Boolean(this.state.versionIdToCopyTo)}
          copyFromOptions={(() => {
            return this.getCopyOptions()
          })()}
          onOk={({ copyFromVersion, setCopyFromVersion }) => {
            this.handleCopySchedule(copyFromVersion, this.state.versionIdToCopyTo, setCopyFromVersion)
          }}
          onCancel={() => {
            this.setState({
              versionIdToCopyTo: null
            })
          }}
          loading={this.state.isUpdateBucketVersionModalLoading}
          basicDateRangeDetails={basicDateRangeDetails}
        />

        <Modal
          title='DELETE BUCKET VERSION'
          visible={Boolean(this.state.deleteBucketVersionId)}
          onOk={this.confirmBucketVersionDeletion}
          onCancel={() => {
            this.setState({
              deleteBucketVersionId: null
            })
          }}
          className='general-modal'
          okText='Delete'
          cancelText='Cancel'
          okButtonProps={{
            disabled: this.state.isBucketVersionDeleting
          }}
          confirmLoading={this.state.isBucketVersionDeleting}
          getContainer={document.getElementById('admin-list')}
          maskClosable={false}
        >
          <p>Are you sure you want to delete this version ?</p>
          {/* <p>This action cannot be undone.</p> */}
        </Modal>

        {
          showBucketVersions?.[bucketId] && (
            <div className='bucket-versions-container'>
              {/* <button onClick={() => this.setState({ updatedVersionBucketItems: {} })}>clear</button> */}
              {defaultBucketItems}
              {reorderedVersions?.map((bucketVersionItem, index) => {
                if (!bucketVersionItem) return null
                const versionId = bucketVersionItem.id
                const isActive = versionId === currentActiveBucketVersion?.id
                const activeItemDroppableId = this.getActiveDroppableId(currentActiveBucketVersion?.id, bucketId)
                const droppableIdData = isActive
                  ? activeItemDroppableId
                  : VERSION_DROPPABLE_ID + versionId + '_' + bucketId
                // const ref = createRef()
                // this.BucketDetailCellVersionRef[bucketVersionItem.id] = createRef()
                // console.log('ref', this.BucketDetailCellVersionRef)
                // console.log('render', this.BucketDetailCellVersionRef[bucketVersionItem.id])
                return (
                  <>
                    {/* <h5>versionId:: {versionId}</h5> */}
                    <BucketDetailCellVersion
                      bucketItemsInVersion={bucketVersionItem.bucketItems}
                      bucketId={bucketId} // TODO:: need to rename this inside component since both are same
                      versionId={bucketVersionItem.id}
                      sourceIndex={1}
                      destinationIndex={2}
                      droppableIdData={droppableIdData}
                      droppableId={bucketVersionItem.id}
                      draggable={
                        bucketVersionItem.bucketId === droppableId ? [] : null
                      }
                      deleteBucketGroupItem={() =>
                        this.deleteBucketGroupItem(bucketVersionItem.id)
                      }
                      clearDragDropId={clearDragDropId}
                      selected={bucketId === bucketVersionItem.bucketId}
                      changeBucket={this.props.changeBucket}
                      // isForceSave={false}
                      // isForceSave={isSavingBucket ? bucketVersionItem.isChanged : undefined}
                      forceSaveCompleted={this.forceSaveCompleted}
                      updateHistory={updateHistory}
                      displayTypes={displayTypes}
                      isCreateBlocked={isCreateBlocked}
                      isUpdateBlocked={isUpdateBlocked}
                      isDeleteBlocked={isDeleteBlocked}
                      subscriptionBucketDetail={bucketDetails}
                      onSave={this.onSave}
                      isSaveAllClicked={false}
                      // isSaveAllClicked={isConfirmClicked && toBeSaved.includes(bucket.bucketId)}
                      draggingTaskId={draggingTaskId}
                      forceFetchSubscription={false}
                      completedSubscription={this.completedSubscription}
                      project={project}
                      isUpdateDisabledContent={isUpdateDisabledContent}
                      isCreateDisabledContent={isCreateDisabledContent}
                      changeAddSearchStatusStatus={
                        this.changeAddSearchStatusStatus
                      }
                      changeLoadingBucket={changeLoadingBucket}
                      bucketGroupId={bucketGroupId}
                      showBucketVersions={false}
                      // new for handling versions alone
                      bucketVersionItem={bucketVersionItem}
                      removeVersionBucketItem={this.removeVersionBucketItem}
                      onBucketVersionAssetTitleChange={this.onBucketVersionAssetTitleChange}
                      onBucketVersionAssetDisplayImageChange={this.onBucketVersionAssetDisplayImageChange}
                      onBucketVersionAssetTitleReset={this.onBucketVersionAssetTitleReset}
                      onBucketVersionAssetDisplayImageReset={this.onBucketVersionAssetDisplayImageReset}
                      handleBucketVersionEnableDisable={this.handleBucketVersionEnableDisable}
                      handleCopySchedule={(versionId) => {
                        this.setState({
                          versionIdToCopyTo: versionId
                        })
                      }}
                      handleBucketVersionModal={handleBucketVersionModal}
                      isActive={isActive}
                      isUpdateBucketVersionModalLoading={this.state.isUpdateBucketVersionModalLoading}
                      handleVersionDeletion={(versionId) => this.setState({ deleteBucketVersionId: versionId })}
                      onAddSearch={this.onAddSearch}
                      getActiveOrVersionDraggableId={this.getActiveOrVersionDraggableId}
                      onChangeFilter={(id, value, bucketVersionItem) => this.onChangeFilter(id, value, ACTION_TYPES.ACTION_ON_BUCKET_VERSION, bucketVersionItem)}
                      onViewApiResponse={this.copyLink}
                      comparisonVersions={this.state.bucketDetailsForComparison?.versions?.[0]?.bucketItems}
                      bucketVersionAPILoading={bucketVersionAPILoading}
                      handleBucketDetailCellState={this.handleBucketDetailCellState}
                      getBucketDetailCellState={this.getBucketDetailCellState}
                      entitiesInsideVersions={this.state.entitiesInsideVersions?.[versionId] || {}}
                      selectedTaskIdsInsideVersions={this.state.selectedTaskIdsInsideVersions?.[versionId] || []}
                      loadVersionBucketDetailsTolistData={this.loadVersionBucketDetailsTolistData}
                      toggleSelectionOnVersions={this.toggleSelectionOnVersions}
                      toggleSelectionInGroupOnVersions={this.toggleSelectionInGroupOnVersions}
                      multiSelectToOnVersions={this.multiSelectToOnVersions}
                      getSelectionDetailsForThisVersion={this.getSelectionDetailsForThisVersion}
                    />
                    <UpdateBucketVersionModal
                      visible={updateBucketVersionModalId === bucketVersionItem?.id}
                      onOk={this.handleBucketVersionUpdation}
                      onCancel={() => {
                        handleBucketVersionModal(null, BUCKET_VERSION_MODAL_TYPES.UPDATE_BUCKET_VERSION_MODAL)
                      }}
                      loading={this.state.isUpdateBucketVersionModalLoading}
                      basicDateRangeDetails={basicDateRangeDetails}
                    />
                  </>
                )
              })}
              {/* <div> */}
              {/* {console.log('this.state.entitiesInsideVersions', this.state.entitiesInsideVersions)} */}
              {/* <p>entitiesInsideVersions :: <pre>{JSON.stringify(this.state.entitiesInsideVersions, null, 2)}</pre></p> */}
              {/* {console.log('details', this.props.bucketDetailsForComparison?.versions?.[0])} */}
              {/* <p>updatedVersionBucketItems :: <pre>{JSON.stringify(this.state.updatedVersionBucketItems, null, 2)}</pre></p> */}
              {/* <p>updatedVersionBucketItemsForTrackingMetaChanges :: <pre>{JSON.stringify(this.state.updatedVersionBucketItemsForTrackingMetaChanges, null, 2)}</pre></p> */}
              {/* </div> */}
            </div>
          )
        }
      </div>
    )
  }
}

BucketDetailCell.propTypes = {
  /** id of selected bucket. */
  id: PropTypes.string,
  /** Source index for bucket item drag and rearrange */
  sourceIndex: PropTypes.number,
  /** Destination index for bucket item drag and rearrange */
  destinationIndex: PropTypes.number,
  /** ID of newly added asset in buckets */
  droppableId: PropTypes.string,
  /** Id of buckets inwhich new asset added */
  draggable: PropTypes.object,
  /** Function to be called to clear drag and drop id */
  clearDragDropId: PropTypes.func,
  /** Function to be called to notify unsaved changes */
  changeBucket: PropTypes.func,
  /** Boolean for force save bucket */
  isForceSave: PropTypes.bool,
  /** Function to be called on complete of forced save of bucket */
  forceSaveCompleted: PropTypes.func,
  /** Boolean for disabling delete */
  isDeleteBlocked: PropTypes.bool,
  /** Boolean for disabling update */
  isUpdateBlocked: PropTypes.bool,
  /** Boolean for disabling create */
  isCreateBlocked: PropTypes.bool
}

const getSortedBucketItemsInsideVersion = (versionList) => {
  const versions = cloneDeep(versionList)
  versions.forEach(versionItem => {
    const bucketItems = versionItem?.bucketItems || []
    bucketItems.sort((a, b) => (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0))
  })
  return versions
}

const getUpdatedStatusList = (bucketDetails) => {
  const { isPublished, publishStartDate, publishEndDate, versions } = bucketDetails
  let status = utilityService.getPublishStatus(isPublished, publishStartDate, publishEndDate)
  versions.forEach(versionItem => {
    const versionStatus = utilityService.getPublishStatus(versionItem.isPublished, versionItem.publishStartDate, versionItem.publishEndDate)
    if (versionStatus === 'PUBLISHED') {
      status = versionStatus
    }
  })
  return status
}

export default withApollo(compose(
  graphql(
    QueryGetBucketDetails,
    {
      skip: ({ bucketId }) => {
        return !bucketId
      },
      options: ({ bucketId }) => {
        return {
          variables: { id: bucketId }
        }
      },
      props: (properties) => {
        let bucketItems
        const props = cloneDeep(properties)
        if (props.data.getBucket) {
          const versions = getSortedBucketItemsInsideVersion(props.data.getBucket?.versions || [])
          props.data.getBucket.versions = versions
          bucketItems = props.data.getBucket.bucketItems
          bucketItems = (bucketItems || []).filter(item => item && (item.type !== 'ASSET' || item.asset)).sort((a, b) => (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0))
          props.data.getBucket.bucketItems = bucketItems
          props.data.getBucket.status = getUpdatedStatusList(props.data.getBucket)
        }
        return {
          bucketDetailsForComparison: cloneDeep(props.data.getBucket),
          bucketDetails: props.data.getBucket,
          isLoading: props.data.loading,
          fetchMoreBucketDetails: () => {
            return props.data.refetch()
          }
          // subscribeToChangeBucket: () => subscribeChangeInBucket(props.data.subscribeToMore, props)
        }
      },
      withRef: true
    }
  ),
  graphql(
    MutationCreateBucketItem,
    {
      options: (props) => ({
        // update: (cache, { data: { createBucket } }) => {
        //   const variables = { limit: 50 }
        //   const listCacheData = _.cloneDeep(cache.readQuery({ query: QueryFilterBuckets, variables }))
        //   if (listCacheData && listCacheData.listBuckets && listCacheData.listBuckets.items) {
        //     listCacheData.listBuckets.items.splice(0, 0, createBucket)
        //     listCacheData.listBuckets.totalCount++
        //   }
        //   cache.writeQuery({
        //     query: QueryFilterBuckets,
        //     data: listCacheData,
        //     variables
        //   })
        // }
      }),
      props: (props) => ({
        createBucketItem: (bucketItemList) => {
          let variables = bucketItemList
          variables.project = props.ownProps.project
          return props.mutate({
            variables
          })
        }
      }),
      withRef: true
    }
  ),
  graphql(
    MutationUpdateBucket,
    {
      // options: ({ bucketId }) => ({
      //   update: (cache, { data: { updateBucket } }) => {
      //     const variables = { id: bucketId }
      //     const cachedData = _.cloneDeep(cache.readQuery({ query: QueryGetBucketDetails, variables }))
      //     if (cachedData && cachedData.getBucket) {
      //       cachedData.getBucket = updateBucket
      //     }
      //     cache.writeQuery({
      //       query: QueryGetBucketDetails,
      //       data: cachedData,
      //       variables
      //     })
      //   }
      // }),
      props: (props) => ({
        updateBucket: (variables) => {
          variables.project = props.ownProps.project
          return props.mutate({
            variables
          })
        }
      }),
      withRef: true
    }
  ),
  graphql(
    MutationSaveAllBuckets,
    {
      props: (props) => ({
        saveAllBuckets: (variables) => {
          variables.project = props.ownProps.project
          return props.mutate({
            variables
          })
        }
      }),
      withRef: true
    }
  ),
  graphql(
    MutationUpdateBucketItem,
    {
      options: (props) => ({
      }),
      props: (props) => ({
        updateBucketItem: (bucketItems) => {
          let variables = bucketItems
          variables.project = props.ownProps.project
          return props.mutate({
            variables
          })
        }
      }),
      withRef: true
    }
  ),
  graphql(
    QueryGetBucketUpdatedDetails,
    {
      skip: ({ bucketId }) => {
        return !bucketId
      },
      options: ({ bucketId }) => {
        return {
          variables: { id: bucketId }
        }
      },
      props: (props) => {
        return {
          bucketUpdatedDetails: _.cloneDeep(props.data.getBucket),
          isLoading: props.data.loading,
          fetchBucketDetails: () => {
            return props.data.refetch()
          }
        }
      },
      withRef: true
    }
  ),
  graphql(
    createBucketVersionMutation,
    {
      props: (props) => ({
        createBucketVersion: (params) => {
          const variables = cloneDeep(params)
          variables.project = props.ownProps.project
          return props.mutate({
            variables
          })
        }
      }),
      withRef: true
    }
  ),
  graphql(
    updateBucketVersionMutation,
    {
      props: (props) => ({
        updateBucketVersion: (params) => {
          const variables = cloneDeep(params)
          variables.project = props.ownProps.project
          return props.mutate({
            variables
          })
        }
      }),
      withRef: true
    }
  ),
  graphql(
    deleteBucketVersionMutation,
    {
      props: (props) => ({
        deleteBucketVersion: (params) => {
          const variables = cloneDeep(params)
          variables.project = props.ownProps.project
          return props.mutate({
            variables
          })
        }
      }),
      withRef: true
    }
  )
)(BucketDetailCell), { withRef: true })
